// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-30T21:52:33.300Z
// Property: Ranch at Hudson Xing (ID: 5673855012044800)
// Collections: 17 amenities, 5 floorplans (live), 25 photos, 77 POIs, 7 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5673855012044800",
  "property_external_id": "4600728",
  "property_zillow_url": "https://www.zillow.com/homedetails/3250-Hudson-Xing-McKinney-TX-75070/83747410_zpid/",
  "property_apartments_url": "https://www.apartments.com/ranch-at-hudson-xing-mckinney-tx/x9b4pvn",
  "property_google_business_url": "https://www.google.com/maps/place/3250+Hudson+Crossing,+McKinney,+TX+75070/@33.1711676,-96.7048534,18z/data=!3m1!4b1!4m5!3m4!1s0x864c142baad66d33:0xc6d3b73b7b465329!8m2!3d33.1714755!4d-96.7042512",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443974197",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ranch-at-hudson-xing",
  "property_name": "Ranch at Hudson Xing",
  "property_website_url": "https://www.ranchathudsonxing.com/",
  "property_domain": "https://www.ranchathudsonxing.com/",
  "property_address": "3250 Hudson Xing",
  "property_full_address": "3250 Hudson Crossing, McKinney, TX 75070",
  "property_address_1": "3250 Hudson Crossing",
  "property_address_2": null,
  "property_address_city": "McKinney",
  "property_address_state": "TX",
  "property_address_zip_full": "75070-6518",
  "property_address_zip": "75070",
  "property_address_country": "US",
  "property_address_county": "Collin County",
  "property_neighborhood_address": "Allen/McKinney",
  "property_address_latitude": "33.1714755",
  "property_address_longitude": "-96.7042512",
  "property_email": "ranchathudson@alapts.com",
  "property_phone": "(972) 542-4500",
  "property_call_tracking_phone": "972-435-6351",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Parkside McKinney living with everyday polish.</strong> Ranch at Hudson Xing pairs one-, two-, and three-bedroom homes with polished finishes, private outdoor space, and community comforts beside open green space—schedule a tour to see it all in person.</p>",
  "property_long_description": "<p><strong>Parkside McKinney living with everyday polish.</strong> At Ranch at Hudson Xing, you’re tucked beside Gabe Nesbitt Community Park, where trails, The Courts of McKinney, the skatepark, Apex Centre, and open green space put recreation right outside your routine. Inside the community, unwind around the <a href=\"/amenities\">pool, spa, sundeck, cabana, and grilling areas</a>, get things done in the business center, or make the most of conveniences like gated access, door-to-door trash pickup, onsite maintenance, online resident services, and a bark park.</p><p>Your home keeps the same easygoing feel with <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, 9-foot ceilings, crown molding, walk-in closets, built-in shelving and desk space, washer and dryer connections, and private patios or balconies. Select homes add wood-style flooring, while kitchens may feature granite countertops and stainless steel appliances. From this Allen/McKinney address, you’re close to Eldorado Parkway, Sam Rayburn Tollway, US 75, Watters Creek, Allen Premium Outlets, and the restaurants, shops, and local character of Historic Downtown McKinney.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-b0b1-71eb-877e-0c4c31d84ef6.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex swimming pool with lounge chairs and building in the background at dusk.",
    "public_id": "019d02ef-b0b1-71eb-877e-0c4c31d84ef6",
    "storage_key": "property/5673855012044800/019d02ef-b0b1-71eb-877e-0c4c31d84ef6.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "248",
  "property_year_built": "2003",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.75806451612904",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8113537.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://ranchathudsonxing.loftliving.com/login",
  "property_apply_now_url": "https://8113537.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e7015-75b6-7268-8d66-b7f9b9c6219b.webp",
  "property_primary_logo_media": {
    "alt_text": "Ranch at Hudson Xing logo with a bull's head.",
    "public_id": "019e7015-75b6-7268-8d66-b7f9b9c6219b",
    "storage_key": "property/5673855012044800/019e7015-75b6-7268-8d66-b7f9b9c6219b.webp",
    "width": 1893,
    "height": 978
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e7015-74e1-74a2-9f54-90f3301a3f93.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ranch at Hudson Xing Premier Apartments logo",
    "public_id": "019e7015-74e1-74a2-9f54-90f3301a3f93",
    "storage_key": "property/5673855012044800/019e7015-74e1-74a2-9f54-90f3301a3f93.webp",
    "width": 1893,
    "height": 978
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e7015-7463-7298-b069-ff86373c50f6.webp",
  "property_icon_media": {
    "alt_text": "Property logo featuring bull horns.",
    "public_id": "019e7015-7463-7298-b069-ff86373c50f6",
    "storage_key": "property/5673855012044800/019e7015-7463-7298-b069-ff86373c50f6.webp",
    "width": 372,
    "height": 373
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e7015-7463-7298-b069-ff86373c50f6.webp",
  "property_fav_icon_media": {
    "alt_text": "Property logo featuring bull horns.",
    "public_id": "019e7015-7463-7298-b069-ff86373c50f6",
    "storage_key": "property/5673855012044800/019e7015-7463-7298-b069-ff86373c50f6.webp",
    "width": 372,
    "height": 373
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f434f-251f-73c1-a212-51d250691159.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f434f-251f-73c1-a212-51d250691159",
    "storage_key": "property/5673855012044800/019f434f-251f-73c1-a212-51d250691159.webp",
    "width": 1280,
    "height": 661
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f434f-128b-773c-beba-748ed477fc9b.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f434f-128b-773c-beba-748ed477fc9b",
    "storage_key": "property/5673855012044800/019f434f-128b-773c-beba-748ed477fc9b.webp",
    "width": 1280,
    "height": 661
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#1c4026",
  "property_secondary_color": "#177932",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#673534",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "621 - 1185",
  "property_sqft_min": "621",
  "property_sqft_max": "1185",
  "property_price_range": "1214 - 2024.33",
  "property_price_min": "1214",
  "property_price_max": "2024.33",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/RanchAtHudsonXing",
  "property_instagram_url": "https://www.instagram.com/ranchathudsonxing",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW-z0pSsUTIYRd5FYe3485sQ",
  "property_youtube_url": "https://www.youtube.com/watch?v=YPijBIo0_DU",
  "property_yelp_url": "https://www.yelp.com/biz/ranch-at-hudson-xing-mckinney",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Momentum meets downtime at Ranch at Hudson Xing.</strong> Tackle tasks in the business center, keep your routine on track in the 24-hour fitness center, then unwind at the resort-style pool, spa, sundeck, cabana, or grilling areas. Gated access, onsite maintenance, door-to-door trash pickup, online resident services, and a bark park add everyday ease, while apartment finishes like 9-foot ceilings, crown molding, walk-in closets, and private patios or balconies bring the comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in McKinney with open layouts, 9-foot ceilings, crown molding, walk-in closets, built-in shelving or desk space, and private patio or balcony options. Select homes add wood-style flooring, granite countertops, stainless steel appliances, garden tubs, and washer/dryer connections—so it’s easy to compare the details that matter before choosing your next layout.</p>",
  "property_home_gallery_blurb": "<p><strong>See the details that make Ranch at Hudson Xing shine.</strong> Preview bright interiors with open kitchens, breakfast-bar counters, stainless steel appliances, built-in shelving, walk-in closets, and patio or balcony space. Then picture the McKinney setting beyond your door—sparkling pool, shaded cabanas, grill areas, fitness center, business center, and green spaces made for easy downtime.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected McKinney living starts here.</strong> From Ranch at Hudson Xing, everyday errands, open-air shopping, and local dining are close by along Eldorado Parkway, District 121, Watters Creek, and Allen Premium Outlets. Stretch out at Gabe Nesbitt Community Park, then head to Historic Downtown McKinney for brick-lined streets, patio dining, live music, and small-shop charm. Explore the map to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise at Ranch at Hudson Xing.</strong> Reviews highlight the helpful office team, courteous maintenance, comfortable apartment layouts, and a McKinney location that keeps daily routines simple.</p><p>Standout mentions include upgraded countertops, spacious rooms, garden tubs, valet trash, gated entry, laundry services, and the swimming pool. Browse the reviews to see what residents value most about life here.</p>",
  "property_neighborhood_blurb": "<p><strong>Stay connected to the best of Allen/McKinney.</strong> Ranch at Hudson Xing puts daily convenience, open-air shopping, and local flavor within easy reach—from quick trips along Eldorado Parkway to evenings at District 121, Watters Creek, or Allen Premium Outlets. Nearby Gabe Nesbitt Community Park brings room to roam with trail connections and major recreation destinations, while Historic Downtown McKinney adds brick-lined streets, independent shops, patio dining, live music, and a classic town-square feel. Use the map below to explore what’s close, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how easily this McKinney apartment community connects it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that keep your day moving.</strong> At Ranch at Hudson Xing, you can shift from productivity to downtime without leaving the community: settle into the business center, keep your routine on track in the 24-hour fitness center, then cool off at the resort-style pool, spa, sundeck, cabana, or grilling areas. Everyday details add ease too, from gated access and onsite maintenance to door-to-door trash pickup, online resident services, and a bark park for four-legged companions.</p><p>Inside your McKinney apartment, polished finishes make the difference—9-foot ceilings, crown molding, walk-in closets, built-in shelving or desk space, and private patios or balconies. Select homes add wood-style flooring, garden tubs, granite countertops, stainless steel appliances, and washer/dryer connections. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make it official?</strong> Ranch at Hudson Xing brings polished parkside living together with comfortable <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, everyday conveniences, and relaxing community spaces. Start your online application today and take the next step toward calling this McKinney apartment community home.</p>",
  "property_contactus_blurb": "<p><strong>Let’s connect.</strong> Have questions about Ranch at Hudson Xing, from available layouts to community conveniences, or need directions to our McKinney address? Reach out to the leasing team today—we’re happy to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Ranch at Hudson Xing?</strong> Start here for quick answers about the community, leasing, everyday conveniences, and life beside Gabe Nesbitt Community Park. If you need anything more specific, the leasing team is happy to help you find the details you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that fits your day.</strong> At Ranch at Hudson Xing, floor plans range from efficient one-bedroom apartments to roomier two- and three-bedroom layouts in McKinney, each designed with practical flow and everyday comfort in mind. Choose a one-bedroom for a streamlined setup, a two-bedroom with two baths for added separation, or a larger three-bedroom layout when you want more room to spread out.</p><p>Inside, your home feels open and polished with details like 9-foot ceilings, crown molding, walk-in closets, built-in shelving or desk space, and private patio or balcony options. Select homes may add wood-style flooring, granite countertops, stainless steel appliances, garden tubs, and washer and dryer connections. Compare availability, finishes, and pricing below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the everyday details in focus.</strong> Browse the gallery to see Ranch at Hudson Xing through bright living rooms, open kitchens, and bedrooms framed by large windows, ceiling fans, and polished trim. Look for practical touches that photograph well and live even better, from breakfast-bar counters and stainless steel appliances to built-in shelving, walk-in closets, and private patio or balcony spaces.</p><p>Outside your apartment, the images shift to the community’s relaxed McKinney setting: a sparkling <a href=\"/amenities\">pool and sundeck</a>, shaded cabana seating, grill areas, a fitness center, business center, and green spaces designed for easy downtime. Like what you see? Pair the photos with <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place near the park.</strong> Use the interactive map to explore available apartments at Ranch at Hudson Xing, then see how this McKinney setting connects you to nearby trails, green space, shopping, dining, and major routes.</p>",
  "property_pets_blurb": "<p><strong>A pet routine that feels easy from day one.</strong> At Ranch at Hudson Xing, cats and dogs are part of the comfort—whether your dog is heading to the on-site bark park or your cat is claiming a sunny spot by the window. Step out for quick leash breaks around the courtyard, linger near the picnic and grilling areas, or unwind at home on your private patio or balcony. When a longer walk is calling, the parkside trail network nearby gives you extra room to stretch your legs in McKinney.</p><p>Ready to find a pet-friendly home base? Explore <a href=\"/floor-plans\">available layouts</a>, see more <a href=\"/amenities\">community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> with your four-legged roommate in mind.</p>",
  "property_referafriend_blurb": "<p><strong>Share parkside McKinney living.</strong> Love the easy access to recreation, polished apartment finishes, and everyday conveniences at Ranch at Hudson Xing? Invite a friend to experience the same relaxed routine—from poolside downtime to thoughtfully designed one-, two-, and three-bedroom homes.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong> Pay rent, submit maintenance requests, and manage your account online at Ranch at Hudson Xing. With onsite maintenance, online resident services, and everyday conveniences like door-to-door trash pickup, staying on top of home is simple.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Ranch at Hudson Xing.</strong> Review after review points to the details that make daily living feel easier: a kind, helpful office team, responsive maintenance, comfortable apartments, and a location residents consistently appreciate.</p><p>Residents call out “great staff, location and apartment,” along with thoughtful features like upgraded countertops, spacious rooms, garden tubs, valet trash service, the swimming pool, laundry services, and gated entry. Maintenance earns especially strong praise for quick follow-through and courteous service. As you browse the ratings, you’ll get a grounded look at what current and past residents value most about life at Ranch at Hudson Xing.</p>",
  "property_created_at": "1752256470899",
  "property_scheduletour_blurb": "<p><strong>See parkside McKinney living up close.</strong> Tour Ranch at Hudson Xing to picture the poolside spaces, polished <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, and everyday conveniences that make this address feel easy from the start. Schedule your visit today and experience the setting in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture everyday polish at Ranch at Hudson Xing, with parkside McKinney access, relaxing community spaces, and one-, two-, and three-bedroom homes designed with easygoing comfort in mind.</p>",
  "property_virtualtours_blurb": "<p><strong>Start with the spaces you can actually step through.</strong> Use the virtual tours to move from Ranch at Hudson Xing’s community overview into the clubhouse, business center, and fitness center, catching details like lounge-style gathering areas, work-ready space, and equipment-lined workout rooms before you ever arrive.</p><p>Then explore apartment walkthroughs for the A1 and A2 one-bedroom layouts plus the B1 and B2 two-bedroom layouts. As you click through, look for open living areas, bright windows, defined kitchen space, walk-in closet potential, built-in shelving or desk details, and patio or balcony connections in select homes. Pair these tours with <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see the McKinney community in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Ranch at Hudson Xing",
  "property_seo_title_home": "Ranch at Hudson Xing | Apartments in Mckinney, TX",
  "property_seo_description_home": "Experience the perfect blend of comfort and convenience at Ranch at Hudson Xing in McKinney, TX. Choose from a variety of thoughtfully designed one to three-bedroom floor plans featuring modern amenities like high ceilings, garden tubs, and spacious walk-in closets. Enjoy our community perks such as a refreshing pool, state-of-the-art fitness center, dog park, and tranquil outdoor spaces. Elevate your lifestyle with online resident services and easy access to a thriving neighborhood. Your ideal home awaits—find your new sanctuary today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Mckinney, TX",
  "property_seo_description_floorplans": "Unlock the perfect blend of comfort and style at Ranch at Hudson Xing in McKinney, TX. Featuring thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes, each space invites you to create lasting memories. Browse our available apartment homes today and find the ideal layout that fits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Mckinney, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience the perfect blend of comfort and convenience at Ranch at Hudson Xing in McKinney, TX. Our spacious one, two, and three-bedroom apartments come with stunning features like high ceilings, garden tubs, and walk-in closets. Unwind by the pool, let your furry friends enjoy the dog park, or stay active in our fully-equipped fitness center. With a business center for your work needs and online resident services at your fingertips, life here is designed with you in mind. Dive into our exceptional amenities and elevate your living experience!",
  "property_seo_title_gallery": "Gallery | Apartments in Mckinney, TX",
  "property_seo_description_gallery": "Capture the essence of McKinney living at Ranch at Hudson Xing. With spacious one, two, and three-bedroom floor plans featuring luxury amenities like tall ceilings, garden tubs, and built-in desks, your perfect home awaits. Enjoy a vibrant lifestyle with a refreshing pool, a pet-friendly dog park, and a serene courtyard. Explore vibrant photo galleries that bring our community to life and envision your future here. Picture yourself living in comfort and style—your new adventure starts now!",
  "property_seo_title_virtualtours": "Virtual Tours | Ranch at Hudson Xing Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Ranch at Hudson Xing in McKinney, TX, where modern living meets comfort. From stylish one-bedroom retreats to spacious three-bedroom homes, our diverse floor plans cater to every lifestyle. Step into your new sanctuary with our immersive virtual tour—your future apartment awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Ranch at Hudson Xing Apartments",
  "property_seo_description_interactivemap": "Experience the perfect blend of comfort and convenience at Ranch at Hudson Xing in McKinney, TX. From spacious one to three-bedroom apartments featuring sunlit layouts with tall ceilings and walk-in closets, to top-notch amenities like a relaxing spa, vibrant dog park, and a state-of-the-art fitness center—every detail is designed for your ideal lifestyle. Utilize our interactive community map to explore available homes, view pricing, and find the perfect space that fits your needs. Your next chapter starts here!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mckinney, TX",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Mckinney at Ranch at Hudson Xing. Our neighborhood is rich with local favorites, parks, and cultural attractions. From cozy one-bedroom apartments to spacious three-bedroom options, your perfect home awaits. Dive into the community’s hidden gems and see what makes this area truly special!",
  "property_seo_title_contact": "Contact Us | Ranch at Hudson Xing",
  "property_seo_description_contact": "Experience the perfect blend of comfort and convenience at Ranch at Hudson Xing in McKinney, TX. With spacious one, two, and three-bedroom floor plans tailored to your lifestyle, we’re here to help you find your dream home. Have questions? Contact our leasing team today and let us assist you on your journey to exceptional living!",
  "property_seo_title_faqs": "FAQs | Apartments in Mckinney, TX",
  "property_seo_description_faqs": "Uncover the charm of Ranch at Hudson Xing in McKinney, TX, where top-notch amenities meet flexible floor plans tailored for your lifestyle. From spacious one, two, and three-bedroom homes equipped with walk-in closets and garden tubs to vibrant community features like a dog park and a refreshing pool—your perfect getaway awaits. Have questions? Browse our FAQs page for insights into our exceptional living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mckinney, TX",
  "property_seo_description_reviews": "Uncover the charm of Ranch at Hudson Xing in McKinney, TX, where vibrant living meets thoughtful design. Our diverse floor plans, from cozy one-bedroom retreats to spacious three-bedroom family homes, offer something for everyone. Enjoy a host of amenities including a refreshing pool, a state-of-the-art fitness center, and a welcoming dog park. With online resident services and luxuries like garden tubs and walk-in closets, your comfort is our priority. Dive into our resident reviews and see why our community feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mckinney, TX",
  "property_seo_description_applynow": "Unveil a life of comfort at Ranch at Hudson Xing in McKinney, TX, where modern floor plans fit your lifestyle—choose from chic one, two, or three-bedroom options. Enjoy luxurious amenities like a sparkling pool, a relaxing spa, and spacious courtyards. Dive into productivity in our business center or unwind at the dog park. With your well-being in mind, we offer fitness facilities, stylish garden tubs, and walk-in closets. Ready to elevate your living experience? Lease online today and find your perfect home!",
  "property_seo_title_residentaccess": "Resident Access | Ranch at Hudson Xing",
  "property_seo_description_residentaccess": "\"Welcome to the Ranch at Hudson Xing resident portal, your gateway to seamless living in McKinney, TX. Conveniently pay rent, schedule maintenance, and manage your community experience—all in one place. Log in now for easy access to your apartment life!\"",
  "property_seo_title_referafriend": "Refer A Friend | Ranch at Hudson Xing",
  "property_seo_description_referafriend": "Refer a friend to Ranch at Hudson Xing in McKinney, TX, where every new neighbor enhances our vibrant community. Share the joy of living in a welcoming atmosphere filled with modern amenities and picturesque surroundings. Great friends make great neighbors—invite your pals to join the fun today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ranch at Hudson Xing",
  "property_seo_description_scheduletour": "\"Step into the lifestyle you've always envisioned at Ranch at Hudson Xing in McKinney, TX. Schedule a tour today to experience modern living, vibrant amenities, and a welcoming community that feels like home!\"",
  "property_seo_title_privacy": "Privacy Policy | Ranch at Hudson Xing",
  "property_seo_description_privacy": "At Ranch at Hudson Xing in McKinney, TX, your privacy is our priority. Uncover how we protect your personal information while you enjoy exceptional living. For peace of mind and transparency, view our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Ranch at Hudson Xing",
  "property_seo_description_accessibility": "\"At Ranch at Hudson Xing in McKinney, TX, we celebrate accessibility for all. Our commitment to digital inclusion ensures everyone can navigate our community seamlessly. Dive into our accessibility statement to learn how we prioritize your experience.\"",
  "property_seo_title_sitemap": "Sitemap | Ranch at Hudson Xing",
  "property_seo_description_sitemap": "\"Navigate your future home at Ranch at Hudson Xing in McKinney, TX. Our sitemap offers a clear path to luxury living, amenities, and community features that make every day exceptional. Let your next chapter unfold!\"",
  "property_seo_title_thankyou": "Thank You | Ranch at Hudson Xing",
  "property_seo_description_thankyou": "Thank you for reaching out to Ranch at Hudson Xing in McKinney, TX! Your next home awaits. A member of our friendly team will be in touch soon to help you find the perfect apartment that fits your lifestyle. Stay tuned for more information about our vibrant community and contemporary living spaces!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320228",
  "amenities": [
    {
      "id": "custom_db982c1a-05fb-4f21-8f48-b1c3acb61c16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd966aea-ae65-489c-82d1-a627e5f943f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000605",
      "title": "Built-In Desk",
      "amount": "0.0000",
      "description": "Built-In Shelving & Desks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02d22932-f96e-499a-aa95-a2dfd7b83782",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Resident Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab9c398b-9ccf-4b7e-bee7-6b10170743bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9179c915-e7c5-4157-b020-2dc2f0c81cae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8004ece0-5fb1-433c-af50-15ad34bba17f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7254fec8-1a03-4399-9698-27e5508c5072",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38cebd29-72f9-43bb-9d71-ecfa5b47825a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16d39ee0-27c7-4748-999d-6097b8d6c6c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_401b6207-08cd-4034-9233-9fb9938bb95a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d06a096a-d875-4a8a-b5ad-90d6377b7d91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a6f3501-31e2-49d3-b580-bff299bdc92e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14793905-d3b8-45d7-b782-ec50d6bbc5d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_391c60d7-404f-451e-a368-6f74c921748c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000682",
      "title": "Spa",
      "amount": "0.0000",
      "description": "Hot Tub",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4433a70a-bc25-44c3-a310-6088433aea66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ad0aa8d-8b7b-45ca-986e-94bb58c101b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3fe98089-d3c5-4a6a-b565-3a0928f0ede2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7b75803b-3945-4612-8f58-bf6099d16883",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-3e8f-77d2-9da7-43b1aa4d431b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and apartment buildings in the background at sunset.",
        "public_id": "019e89ac-3e8f-77d2-9da7-43b1aa4d431b",
        "storage_key": "property/5673855012044800/019e89ac-3e8f-77d2-9da7-43b1aa4d431b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a relaxing evening by the sparkling swimming pool and rejuvenating hot tub, surrounded by the beautiful architecture of the community.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and apartment buildings in the background at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f1c16ff-2dcc-488e-9fd1-a1a6e8863fb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-4163-728f-b62c-b4cbae652f79.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with gray walls, comfortable sofa, glass coffee table, and stainless steel appliances.",
        "public_id": "019e89ac-4163-728f-b62c-b4cbae652f79",
        "storage_key": "property/5673855012044800/019e89ac-4163-728f-b62c-b4cbae652f79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort with this stylish living and kitchen area, perfect for relaxation and entertaining. Features a sleek sofa, modern kitchen, and elegant decor.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with gray walls, comfortable sofa, glass coffee table, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b906a288-b5eb-40cd-9a28-d15fbc13a05f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-4966-7453-88ae-f6b083ae1df7.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with bar seating in an apartment",
        "public_id": "019e89ac-4966-7453-88ae-f6b083ae1df7",
        "storage_key": "property/5673855012044800/019e89ac-4966-7453-88ae-f6b083ae1df7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish dining area with a round table and chairs adjacent to a modern kitchen with granite countertops and stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area and kitchen with bar seating in an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b751856-3ea5-4cb1-9f22-7d84a507c2b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-3e36-74d3-8619-78e34ea03f47.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with a paved walkway and green grass.",
        "public_id": "019e89ac-3e36-74d3-8619-78e34ea03f47",
        "storage_key": "property/5673855012044800/019e89ac-3e36-74d3-8619-78e34ea03f47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living at this beautiful apartment complex, featuring well-maintained exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with a paved walkway and green grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c19331c7-7c6c-4c65-a5f9-7a19e978d9c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-48e6-70f8-86a2-86b9b21cb972.webp",
      "image_media": {
        "alt_text": "Lobby area with coffee station, seating, and gym visible through glass.",
        "public_id": "019e89ac-48e6-70f8-86a2-86b9b21cb972",
        "storage_key": "property/5673855012044800/019e89ac-48e6-70f8-86a2-86b9b21cb972.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern and inviting lobby featuring a coffee station, comfortable seating, and a glimpse into the well-equipped fitness center.",
      "link": "",
      "alt_text": "Lobby area with coffee station, seating, and gym visible through glass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d603758-f4e5-4879-9c02-2e3b781dafe1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-3cd9-7559-b70e-255c01169a55.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge area with fireplace, seating, and dining table.",
        "public_id": "019e89ac-3cd9-7559-b70e-255c01169a55",
        "storage_key": "property/5673855012044800/019e89ac-3cd9-7559-b70e-255c01169a55.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and a modern dining area perfect for socializing or quiet work.",
      "link": "",
      "alt_text": "Modern apartment community lounge area with fireplace, seating, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_181e578a-8d00-4480-8564-44bfdebcfb8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-465f-7579-8be0-15d0d735dd8d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019e89ac-465f-7579-8be0-15d0d735dd8d",
        "storage_key": "property/5673855012044800/019e89ac-465f-7579-8be0-15d0d735dd8d.webp",
        "width": 2892,
        "height": 1927
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxation and fun. The adjacent clubhouse provides a comfortable gathering space.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d02b9973-f1ab-4e07-baf0-3c78aa5c3b55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-38b9-77dc-83f4-1de8bbe1e704.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, modern artwork, and a desk area.",
        "public_id": "019e89ac-38b9-77dc-83f4-1de8bbe1e704",
        "storage_key": "property/5673855012044800/019e89ac-38b9-77dc-83f4-1de8bbe1e704.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, contemporary wall art, and a convenient workspace.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, modern artwork, and a desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd02e3b8-5ae1-4c66-8104-5c05b239f05b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-3ae7-71a8-b3c9-c18888ce37a8.webp",
      "image_media": {
        "alt_text": "Modern living room with dark grey couch, kitchen area, and dining table.",
        "public_id": "019e89ac-3ae7-71a8-b3c9-c18888ce37a8",
        "storage_key": "property/5673855012044800/019e89ac-3ae7-71a8-b3c9-c18888ce37a8.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a modern kitchen, comfortable seating, and a dining space, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room with dark grey couch, kitchen area, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5c3966e-fdfc-4080-a345-16de8c35e3be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-2d79-7752-9801-cdd1230b8907.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a pergola, next to a gazebo with a grill.",
        "public_id": "019e89ac-2d79-7752-9801-cdd1230b8907",
        "storage_key": "property/5673855012044800/019e89ac-2d79-7752-9801-cdd1230b8907.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling in this community amenity space, featuring a covered patio with seating and a gazebo with a built-in grill.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and chairs under a pergola, next to a gazebo with a grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e00cb674-666e-4195-ab67-2ad1119c1ff4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-2d12-745b-881a-f58e98280431.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances, granite countertops, and a breakfast bar.",
        "public_id": "019e89ac-2d12-745b-881a-f58e98280431",
        "storage_key": "property/5673855012044800/019e89ac-2d12-745b-881a-f58e98280431.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a modern and functional kitchen space, perfect for cooking and entertaining, with a adjacent dining area.",
      "link": "",
      "alt_text": "Dining area and kitchen with stainless steel appliances, granite countertops, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b854d86f-9a2c-4c05-84c6-c46205a7e6b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-2b7b-71a3-8840-e978b01b7fcf.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a fireplace, seating, and decorative elements.",
        "public_id": "019e89ac-2b7b-71a3-8840-e978b01b7fcf",
        "storage_key": "property/5673855012044800/019e89ac-2b7b-71a3-8840-e978b01b7fcf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring a cozy fireplace and comfortable seating areas for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern community lounge with a fireplace, seating, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc44d63f-4777-46f8-a52e-c7d7e6149e96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-2e66-729d-b65c-f2f91fa3ef05.webp",
      "image_media": {
        "alt_text": "Spinning bikes in a fitness room with a TV and horse artwork.",
        "public_id": "019e89ac-2e66-729d-b65c-f2f91fa3ef05",
        "storage_key": "property/5673855012044800/019e89ac-2e66-729d-b65c-f2f91fa3ef05.webp",
        "width": 3006,
        "height": 2004
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern spinning bikes and entertainment.",
      "link": "",
      "alt_text": "Spinning bikes in a fitness room with a TV and horse artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf485a47-7d60-4d6d-af28-502cbf3ec140",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-1721-70bd-897c-42f62449fdb2.webp",
      "image_media": {
        "alt_text": "Ranch at Hudson Xing premier apartments monument sign with landscaping and building exterior.",
        "public_id": "019e89ac-1721-70bd-897c-42f62449fdb2",
        "storage_key": "property/5673855012044800/019e89ac-1721-70bd-897c-42f62449fdb2.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Community",
      "description": "Welcome to Ranch at Hudson Xing Premier Apartments. This exterior shot features the monument sign and the apartment building entrance, surrounded by lush landscaping.",
      "link": "",
      "alt_text": "Ranch at Hudson Xing premier apartments monument sign with landscaping and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_554011b4-490d-453b-a9b7-94f7ba63d11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-16b3-7507-8ed2-48a1f8907514.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and waterfalls in a multifamily community.",
        "public_id": "019e89ac-16b3-7507-8ed2-48a1f8907514",
        "storage_key": "property/5673855012044800/019e89ac-16b3-7507-8ed2-48a1f8907514.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with waterfalls and comfortable lounge chairs. Perfect for soaking up the sun or unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and waterfalls in a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9e9901e-b8c2-4f6b-b015-725d5ca011d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-279f-778b-bbfb-12713c934698.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub/shower.",
        "public_id": "019e89ac-279f-778b-bbfb-12713c934698",
        "storage_key": "property/5673855012044800/019e89ac-279f-778b-bbfb-12713c934698.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity, toilet, and a bathtub with a shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5344957-a0f0-41f3-861d-a4e92f47c9b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-1593-7299-a738-93696b9745d5.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and large mirror.",
        "public_id": "019e89ac-1593-7299-a738-93696b9745d5",
        "storage_key": "property/5673855012044800/019e89ac-1593-7299-a738-93696b9745d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relaxing bedroom featuring a king-sized bed, elegant dresser, and a full-length mirror. Perfect for unwinding.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e16af43b-bf9b-40a0-8b0d-e26c1de3da61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-1597-705e-8eb2-bf01fb1fb89c.webp",
      "image_media": {
        "alt_text": "Stylish living room with gray sofa, glass coffee table, and modern art.",
        "public_id": "019e89ac-1597-705e-8eb2-bf01fb1fb89c",
        "storage_key": "property/5673855012044800/019e89ac-1597-705e-8eb2-bf01fb1fb89c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A chic and inviting living room featuring a plush gray sofa, a sleek glass coffee table, and captivating modern artwork, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Stylish living room with gray sofa, glass coffee table, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe79a399-4d23-4aaa-ab55-5b0d6591fb5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-2290-75bd-b63d-31fc8ba79116.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight machines, and exercise balls.",
        "public_id": "019e89ac-2290-75bd-b63d-31fc8ba79116",
        "storage_key": "property/5673855012044800/019e89ac-2290-75bd-b63d-31fc8ba79116.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features cardio equipment, weight machines, and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47a001a7-cf61-4a02-a8da-ac9555d0dba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-1558-734a-a660-92ea90bba265.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with balconies and outdoor stairs at dusk.",
        "public_id": "019e89ac-1558-734a-a660-92ea90bba265",
        "storage_key": "property/5673855012044800/019e89ac-1558-734a-a660-92ea90bba265.webp",
        "width": 2830,
        "height": 1887
      },
      "title": "Community",
      "description": "Beautiful apartment building exterior with brick accents, balconies, and lush green lawn, illuminated at dusk for a welcoming ambiance.",
      "link": "",
      "alt_text": "Exterior of an apartment building with balconies and outdoor stairs at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c1ac682-3589-4609-99cb-7b1cb3cdd508",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-1485-7068-ae7a-116489c964bc.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a dark sofa, accent chairs, coffee table, and an open kitchen in the background.",
        "public_id": "019e89ac-1485-7068-ae7a-116489c964bc",
        "storage_key": "property/5673855012044800/019e89ac-1485-7068-ae7a-116489c964bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a fully equipped kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Modern lounge area with a dark sofa, accent chairs, coffee table, and an open kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2bdf986-d5fe-4f91-93c8-568e45cb700a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-0bf4-731f-af3f-c8a7a9bd4151.webp",
      "image_media": {
        "alt_text": "Apartment complex pool and building at dusk.",
        "public_id": "019e89ac-0bf4-731f-af3f-c8a7a9bd4151",
        "storage_key": "property/5673855012044800/019e89ac-0bf4-731f-af3f-c8a7a9bd4151.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. The perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Apartment complex pool and building at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c543889d-f2f2-44d2-a008-739e8a9fbac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-08c8-738a-b5d0-434ec38b6546.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, glass coffee table, and abstract art.",
        "public_id": "019e89ac-08c8-738a-b5d0-434ec38b6546",
        "storage_key": "property/5673855012044800/019e89ac-08c8-738a-b5d0-434ec38b6546.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush gray sofa, a sleek glass coffee table, and elegant abstract wall art.",
      "link": "",
      "alt_text": "Modern living room with gray sofa, glass coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f7dd70b-300d-4843-9a63-0066425ffa6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ac-0897-72db-8812-476f723bddec.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and chairs.",
        "public_id": "019e89ac-0897-72db-8812-476f723bddec",
        "storage_key": "property/5673855012044800/019e89ac-0897-72db-8812-476f723bddec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and printers for all your work-from-home needs.",
      "link": "",
      "alt_text": "Business center with computers, printers, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14e3fb23-4b82-46e6-ba7b-402aff056271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e89ab-ffde-74ef-be29-7a14899f2b5e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and medicine balls.",
        "public_id": "019e89ab-ffde-74ef-be29-7a14899f2b5e",
        "storage_key": "property/5673855012044800/019e89ab-ffde-74ef-be29-7a14899f2b5e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, an elliptical, and a selection of medicine balls and weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_991e32db2d0ae723c4673161",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Cajun Fish Grill",
      "poi_type": "Restaurants",
      "poi_address": "2960 Eldorado Pkwy Ste 5, McKinney, TX 75072, USA",
      "poi_short_description": "Casual eatery serving traditional Cajun cuisine including gumbos, po'boys and fried fare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-3614-70ee-9028-657d71edf294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-3614-70ee-9028-657d71edf294",
        "storage_key": "property/5673855012044800/019f1502-3614-70ee-9028-657d71edf294.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cajunfishgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2580663762883719671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cajun-fish-grill",
      "poi_latitude": "33.1689247",
      "poi_longitude": "-96.6634918",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-548-5302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKyemkxwRTIYR9zFo9wRc0CM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "ec_104604f7413a7b219ae26a8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Heian Handroll Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "2960 Eldorado Pkwy Ste 50, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-3a51-75ea-a740-51446875f45c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-3a51-75ea-a740-51446875f45c",
        "storage_key": "property/5673855012044800/019f1502-3a51-75ea-a740-51446875f45c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.instagram.com/heian.mckinney?igsh=MWtlN3V0a2dhMWVtZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=15149104811756266682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heian-handroll-sushi-bar",
      "poi_latitude": "33.1689276",
      "poi_longitude": "-96.6641455",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-308-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbE7mCcXTIYRuqTkGZBuPNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_88fa83c8588c04c44adad376",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Añejo Mexican Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "4150 Eldorado Pkwy Ste 500, McKinney, TX 75070, USA",
      "poi_short_description": "Unfussy strip-mall outlet furnishing typical Mexican & Tex-Mex snacks & plates, plus happy hours.",
      "poi_long_description": "Unfussy strip-mall outlet furnishing typical Mexican & Tex-Mex snacks & plates, plus happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-373e-7013-959a-6f5f41d31a80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-373e-7013-959a-6f5f41d31a80",
        "storage_key": "property/5673855012044800/019f1502-373e-7013-959a-6f5f41d31a80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17411255892296281287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aejo-mexican-grill--bar",
      "poi_latitude": "33.1689024",
      "poi_longitude": "-96.6708726",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-548-4869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZOUBrMXTIYRxyy_Ofw0ofE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1bf10ff964d137025c4fa15f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Tutto Italian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "4150 Eldorado Pkwy Ste 600, McKinney, TX 75070, USA",
      "poi_short_description": "Casual eatery specializing in familiar Italian fare such as lasagna, pizza and pasta.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-3a05-759e-91f2-400c0c1cd474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-3a05-759e-91f2-400c0c1cd474",
        "storage_key": "property/5673855012044800/019f1502-3a05-759e-91f2-400c0c1cd474.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tuttoitaliankitchen.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170901369855949095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tutto-italian-kitchen",
      "poi_latitude": "33.1689644",
      "poi_longitude": "-96.670999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-548-4721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx7lUoL0XTIYRJzkwI5wDB5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_ee3e7acdbb8c1f7cea9effc2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Tailgaters Mckinney - Best Sports Bar, Game bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4150 Eldorado Pkwy Ste 800, McKinney, TX 75070, USA",
      "poi_short_description": "American pub grub, draft beer & sports on TV in a lively hangout with poker & karaoke nights.",
      "poi_long_description": "American pub grub, draft beer & sports on TV in a lively hangout with poker & karaoke nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-2f68-741a-992d-319d16aef605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-2f68-741a-992d-319d16aef605",
        "storage_key": "property/5673855012044800/019f1502-2f68-741a-992d-319d16aef605.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://tailgaterstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3692620455148396248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tailgaters-mckinney---best-sports-bar-game-bar--grill",
      "poi_latitude": "33.1691316",
      "poi_longitude": "-96.6713683",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-547-9779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e4-7792-a32d-05b54f7bdd75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e4-7792-a32d-05b54f7bdd75",
        "storage_key": "property/5673855012044800/019f1502-85e4-7792-a32d-05b54f7bdd75.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHS2VxqkWTIYR2B52V73SPjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_3f4e534d003b066fa13d4ea7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Sweetwaters Coffee & Tea",
      "poi_type": "Restaurants",
      "poi_address": "4701 S Custer Rd Ste 500, McKinney, TX 75070, USA",
      "poi_short_description": "Local chain serving coffee, tea & shakes, plus pastries & light eats, in a stylish, relaxed space.",
      "poi_long_description": "Local chain serving coffee, tea & shakes, plus pastries & light eats, in a stylish, relaxed space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-2f73-7462-beb1-2624a24c876a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-2f73-7462-beb1-2624a24c876a",
        "storage_key": "property/5673855012044800/019f1502-2f73-7462-beb1-2624a24c876a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sweetwaterscafe.com/tx-mckinney-craig-ranch/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1543797383514883184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetwaters-coffee--tea",
      "poi_latitude": "33.1548121",
      "poi_longitude": "-96.7324198",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-369-7830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85f3-779b-a75b-71e0407d6712.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85f3-779b-a75b-71e0407d6712",
        "storage_key": "property/5673855012044800/019f1502-85f3-779b-a75b-71e0407d6712.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJBTzedYAXTIYRcASVeYqrbBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_c5a136f64a3bdc93ed835521",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Eggsquisite Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2058 W University Dr Ste 800, McKinney, TX 75071, USA",
      "poi_short_description": "Cozy brunch, breakfast and lunch spot offering eggs and pancakes plus Italian coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-322c-770f-ac23-e09329125118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-322c-770f-ac23-e09329125118",
        "storage_key": "property/5673855012044800/019f1502-322c-770f-ac23-e09329125118.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theeggsquisitecafe.com/mckinney",
      "poi_directions_map_url": "https://maps.google.com/?cid=4443681849396988585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eggsquisite-cafe",
      "poi_latitude": "33.2179177",
      "poi_longitude": "-96.6393848",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 469-796-5007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWoaXgoTTIYRqYooMBkhqz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_6ef27b0d671d21ee13915065",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "LOYO Burger",
      "poi_type": "Restaurants",
      "poi_address": "216 W Virginia St Ste 102, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-36d1-73ff-a8ea-44a163db2884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-36d1-73ff-a8ea-44a163db2884",
        "storage_key": "property/5673855012044800/019f1502-36d1-73ff-a8ea-44a163db2884.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.loyoburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7241463243059997904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loyo-burger",
      "poi_latitude": "33.1982874",
      "poi_longitude": "-96.6172529",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-942-8038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxWJ4v4TTIYR0Kyj4HPYfmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_e470019a7fed008502967be6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Hutchins BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1301 N Tennessee St, McKinney, TX 75069, USA",
      "poi_short_description": "Local BBQ fixture serving up brisket, ribs & fried catfish in rustic-chic surrounds.",
      "poi_long_description": "Local BBQ fixture serving up brisket, ribs & fried catfish in rustic-chic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f14fb-7410-70de-be0b-b4b971b6cd1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-7410-70de-be0b-b4b971b6cd1d",
        "storage_key": "property/5673855012044800/019f14fb-7410-70de-be0b-b4b971b6cd1d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hutchinsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16734697326257327246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchins-bbq",
      "poi_latitude": "33.2112483",
      "poi_longitude": "-96.6154684",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-548-2629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYydEW1ESTIYRjkw_042WPeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_29f496ca454bd95e568e38e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Cadillac Pizza Pub",
      "poi_type": "Restaurants",
      "poi_address": "112 S Kentucky St, McKinney, TX 75069, USA",
      "poi_short_description": "Brick-walled pub with large pizza oven, huge beer and cocktail menus and music five nights a week.",
      "poi_long_description": "Brick-walled pub with large pizza oven, huge beer and cocktail menus and music five nights a week.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-322e-7489-9fe7-b463fb96cc84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-322e-7489-9fe7-b463fb96cc84",
        "storage_key": "property/5673855012044800/019f1502-322e-7489-9fe7-b463fb96cc84.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://www.cadillacpizzapub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673129586504751853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadillac-pizza-pub",
      "poi_latitude": "33.196774",
      "poi_longitude": "-96.616042",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-547-3833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzasGEoSTIYR7dobvDYA4K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_915c34ff06317b373882f907",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Harvest at the Masonic",
      "poi_type": "Restaurants",
      "poi_address": "215 N Kentucky St, McKinney, TX 75069, USA",
      "poi_short_description": "Rustic-chic restaurant offering sustainable locally-sourced seasonal American fare & drinks.",
      "poi_long_description": "Rustic-chic restaurant offering sustainable locally-sourced seasonal American fare & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4041-70bd-bd75-feb1ca3dd309.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4041-70bd-bd75-feb1ca3dd309",
        "storage_key": "property/5673855012044800/019f1502-4041-70bd-bd75-feb1ca3dd309.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.harvesttx.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp%20listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5678494268390105827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harvest-at-the-masonic",
      "poi_latitude": "33.1985331",
      "poi_longitude": "-96.6160629",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 214-726-0251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTghjEkSTIYR4-J7fnMQzk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_db1257c29ac3551a4c36f1ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "The Yard McKinney TX",
      "poi_type": "Restaurants",
      "poi_address": "107 S Church St, McKinney, TX 75069, USA",
      "poi_short_description": "Massive outdoor dining space for enjoying beer, frozen drinks, tacos, burgers & chicken fried steak.",
      "poi_long_description": "Massive outdoor dining space for enjoying beer, frozen drinks, tacos, burgers & chicken fried steak.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-49fe-7294-aeac-a96b387914b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-49fe-7294-aeac-a96b387914b1",
        "storage_key": "property/5673855012044800/019f1502-49fe-7294-aeac-a96b387914b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.yardtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17131837259207050645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yard-mckinney-tx",
      "poi_latitude": "33.1963957",
      "poi_longitude": "-96.61715900000002",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-631-0035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e5-76e9-902a-751ca776aa19",
        "storage_key": "property/5673855012044800/019d02ef-f8e5-76e9-902a-751ca776aa19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV1T-K2ETTIYRlYXWCDiDwO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5b2be0c8d1a739d494c70512",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Uncork'd Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "301 N Custer Rd #180, McKinney, TX 75071, USA",
      "poi_short_description": "Bar and grill serving steaks, seafood, and sandwiches in a laid-back setting with regular live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-3c5c-70e8-8565-745a9ecbf0df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-3c5c-70e8-8565-745a9ecbf0df",
        "storage_key": "property/5673855012044800/019f1502-3c5c-70e8-8565-745a9ecbf0df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://uncorkdwinebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6500513233606796275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncorkd-bar--grill",
      "poi_latitude": "33.2056268",
      "poi_longitude": "-96.7334858",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-592-8841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e4-7792-a32d-05b54f7bdd75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e4-7792-a32d-05b54f7bdd75",
        "storage_key": "property/5673855012044800/019f1502-85e4-7792-a32d-05b54f7bdd75.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7SVRxl0VTIYR8-PbQlh2Nlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_ed78e4b31141e997f86944c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "3001 S Hardin Blvd, McKinney, TX 75070, USA",
      "poi_short_description": "Grocery chain featuring a bakery, a pharmacy, fresh produce and clean shelves.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-436c-766f-ba51-cf746cf84838.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-436c-766f-ba51-cf746cf84838",
        "storage_key": "property/5673855012044800/019f1502-436c-766f-ba51-cf746cf84838.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/mckinney/3001-hardin-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1121078406389856269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "33.1669663",
      "poi_longitude": "-96.6631643",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-678-3677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e2-77ea-acc2-97293ea6d488",
        "storage_key": "property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfemGzlQRTIYRDXg68t7ejg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_90eb627864370808fbc6c3df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Clean grocery store featuring organic items such as fresh fruit and vegetables, plus meat, seafood and gluten-free products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4193-741f-ab9d-377aa45cbe30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4193-741f-ab9d-377aa45cbe30",
        "storage_key": "property/5673855012044800/019f1502-4193-741f-ab9d-377aa45cbe30.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/mckinney/6100-w-el-dorado-pkwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295726405432914642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "33.1754798",
      "poi_longitude": "-96.695674",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-548-5140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e2-77ea-acc2-97293ea6d488",
        "storage_key": "property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7jLBiYUTIYR0jJE5oKgP2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_30fb6c4fe558fdf4c48cd920",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5001 McKinney Ranch Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Department store offering a range of items, including electronics, appliances, clothing, toys, and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-49fe-7294-aeac-a5a852bec6e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-49fe-7294-aeac-a5a852bec6e6",
        "storage_key": "property/5673855012044800/019f1502-49fe-7294-aeac-a5a852bec6e6.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5211-mckinney-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4288877861563247368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.1560381",
      "poi_longitude": "-96.6823574",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-529-5046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e7-74ed-8f81-70153b119b68",
        "storage_key": "property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkzbH4bwWTIYRCKuDD7EnhTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_bfbdf2b765147845f51291d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4ac5-7388-86d8-f0cb7abfbd9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4ac5-7388-86d8-f0cb7abfbd9f",
        "storage_key": "property/5673855012044800/019f1502-4ac5-7388-86d8-f0cb7abfbd9f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mckinney-tx-pharmacies/2100-el-dorado-pkwy-mckinney-tx-75070/storeid=8321?WT.mc_id=LS_GOOGLE_RX_8321",
      "poi_directions_map_url": "https://maps.google.com/?cid=6282874899493905916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.1726567",
      "poi_longitude": "-96.6446875",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-585-0472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e3-74b3-9439-36c7f26e1f10",
        "storage_key": "property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1b4NuATTIYR_GWN2G5BMVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_92fc72281914331b219459b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3001 Eldorado Pkwy Walgreens, McKinney, TX 75070, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-51c8-753f-889b-481a615f9f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-51c8-753f-889b-481a615f9f3e",
        "storage_key": "property/5673855012044800/019f1502-51c8-753f-889b-481a615f9f3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3001+eldorado+pkwy-mckinney-tx-75070/id=4663",
      "poi_directions_map_url": "https://maps.google.com/?cid=10510386196824957680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.1671841",
      "poi_longitude": "-96.6654986",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-540-6667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6LarDkXTIYR8KLrQY9k3JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2c040b8c658f4bf332b97b43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8801 Stacy Rd, McKinney, TX 75070, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4d8a-726d-91bc-56da0b4f25ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4d8a-726d-91bc-56da0b4f25ef",
        "storage_key": "property/5673855012044800/019f1502-4d8a-726d-91bc-56da0b4f25ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/mckinney/8801-stacy-rd/l827",
      "poi_directions_map_url": "https://maps.google.com/?cid=1278603129453171324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.1515314",
      "poi_longitude": "-96.7306479",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e2-77ea-acc2-97293ea6d488",
        "storage_key": "property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xIWTIYRfFLCm8WCvhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_1dd00399562ba2e964bf3a36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "8700 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-c55b-766a-9984-9eff925ed9c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-c55b-766a-9984-9eff925ed9c8",
        "storage_key": "property/5673855012044800/019d02ef-c55b-766a-9984-9eff925ed9c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/mckinney/h-e-b-mckinney-794?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores&utm_content=mckinney",
      "poi_directions_map_url": "https://maps.google.com/?cid=11583601781760167388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "33.1761683",
      "poi_longitude": "-96.7282316",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-631-7483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e2-77ea-acc2-97293ea6d488",
        "storage_key": "property/5673855012044800/019d02ef-f8e2-77ea-acc2-97293ea6d488.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5afxVBcVTIYR3I1lrXI4waA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1277aad1cb56cb0ea987296a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 S Custer Rd, McKinney, TX 75072, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-523c-711e-a0f2-92ad3b1d3658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-523c-711e-a0f2-92ad3b1d3658",
        "storage_key": "property/5673855012044800/019f1502-523c-711e-a0f2-92ad3b1d3658.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/mckinney/100-s-custer-rd-37099?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6927607639961947985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "33.2030865",
      "poi_longitude": "-96.7337977",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-347-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85df-7671-94f8-1ff93d28f258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85df-7671-94f8-1ff93d28f258",
        "storage_key": "property/5673855012044800/019f1502-85df-7671-94f8-1ff93d28f258.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ__7nlksVTIYRUc82y3HOI2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_da0a0f65d74031599dd10a32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1515 N Central Expy N, McKinney, TX 75070, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4bf1-75af-a363-1f37733dc4e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4bf1-75af-a363-1f37733dc4e0",
        "storage_key": "property/5673855012044800/019f1502-4bf1-75af-a363-1f37733dc4e0.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Mckinney/TX/Mckinney/75070/528?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12262310879178342534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.2119639",
      "poi_longitude": "-96.6394858",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-569-9909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e7-74ed-8f81-70153b119b68",
        "storage_key": "property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP_A5RKETTIYRhkDVrsZ6LKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_33ef333750803422f752098f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2025 N Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5127-74ae-b450-8339c4b703ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5127-74ae-b450-8339c4b703ae",
        "storage_key": "property/5673855012044800/019f1502-5127-74ae-b450-8339c4b703ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/mckinney/2335",
      "poi_directions_map_url": "https://maps.google.com/?cid=12487124086199676793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.2204051",
      "poi_longitude": "-96.6387697",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 469-525-4974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e7-74ed-8f81-70153b119b68",
        "storage_key": "property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG6mzdQkTTIYRee8nYDItS60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_75ffc25f88dfd56b1ac639ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Edris Elliott Elementary School",
      "poi_type": "Education",
      "poi_address": "3721 Hudson Crossing, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5504-74a9-acf8-b7c34724c783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5504-74a9-acf8-b7c34724c783",
        "storage_key": "property/5673855012044800/019f1502-5504-74a9-acf8-b7c34724c783.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://schools.friscoisd.org/campus/elementary/elliott/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=13844531693887687351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edris-elliott-elementary-school",
      "poi_latitude": "33.1647826",
      "poi_longitude": "-96.7038551",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-633-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB9RCHYEWTIYRtwrQXzmoIcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_cecd0fd8d7ef63c0255d2453",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Scoggins Middle School",
      "poi_type": "Education",
      "poi_address": "7070 Stacy Rd, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-56da-7228-9a3f-38f45957d9f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-56da-7228-9a3f-38f45957d9f4",
        "storage_key": "property/5673855012044800/019f1502-56da-7228-9a3f-38f45957d9f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.friscoisd.org/o/scoggins",
      "poi_directions_map_url": "https://maps.google.com/?cid=3827912169244642389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scoggins-middle-school",
      "poi_latitude": "33.15359",
      "poi_longitude": "-96.709035",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-633-5150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ_7w6WMWTIYRVcw4N9Z5HzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_b8554d62f5f4cba95a982cb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Emerson High School",
      "poi_type": "Education",
      "poi_address": "6300 Collin McKinney Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://schools.friscoisd.org/campus/high-school/emerson/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=18212641353837429436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerson-high-school",
      "poi_latitude": "33.1466789",
      "poi_longitude": "-96.6991581",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-633-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4UoTMB0XTIYRvMIRDdFMwPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_30e8a2f47ee41c7d592d1be0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Wortham Intermediate School",
      "poi_type": "Education",
      "poi_address": "7404 Kickapoo Dr, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://schools.friscoisd.org/wortham",
      "poi_directions_map_url": "https://maps.google.com/?cid=8896993562912193708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wortham-intermediate-school",
      "poi_latitude": "33.1477476",
      "poi_longitude": "-96.71483030000002",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-633-3475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3YUbv4oXTIYRrHxR1oF4eHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_b48c2f7c63d0c0c029950eef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Wonderland Montessori School in McKinney US",
      "poi_type": "Education",
      "poi_address": "Wonderland Montessori, 3132 Hudson Crossing, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-52ad-7708-a461-9ab6e054923a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-52ad-7708-a461-9ab6e054923a",
        "storage_key": "property/5673855012044800/019f1502-52ad-7708-a461-9ab6e054923a.webp",
        "width": 1200,
        "height": 600
      },
      "poi_business_url": "https://www.wonderlandmontessori.com/mckinney",
      "poi_directions_map_url": "https://maps.google.com/?cid=2890194620919838244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wonderland-montessori-school-in-mckinney-us",
      "poi_latitude": "33.1716329",
      "poi_longitude": "-96.7025905",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-540-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ70cYtisUTIYRJPar37EIHCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4d79e256dcc2e46608427c3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Kids 'R' Kids Learning Academy of McKinney",
      "poi_type": "Education",
      "poi_address": "2910 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-54e8-70fc-8eaa-f1cd87f208b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-54e8-70fc-8eaa-f1cd87f208b9",
        "storage_key": "property/5673855012044800/019f1502-54e8-70fc-8eaa-f1cd87f208b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kidsrkidsmckinney.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16770376367535696691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-mckinney",
      "poi_latitude": "33.1691738",
      "poi_longitude": "-96.6626705",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-540-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw30sQFURTIYRMyuS-HNYvOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_9ba8f6862182ee537fc3f676",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Primrose School of Eldorado",
      "poi_type": "Education",
      "poi_address": "3999 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Childcare and education provider with several programs for kids from infancy to kindergarten.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-55a8-7764-a035-4d4cb58975f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-55a8-7764-a035-4d4cb58975f9",
        "storage_key": "property/5673855012044800/019f1502-55a8-7764-a035-4d4cb58975f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/eldorado/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5255852799814551624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-eldorado",
      "poi_latitude": "33.1673345",
      "poi_longitude": "-96.6692832",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-529-2091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5XLDf6kWTIYRSEiwVEaK8Eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_39a3a3fdbb74d36816a424ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Campus",
      "poi_type": "Education",
      "poi_address": "2200 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5a67-7526-a0f9-4df8e4e32fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5a67-7526-a0f9-4df8e4e32fdc",
        "storage_key": "property/5673855012044800/019f1502-5a67-7526-a0f9-4df8e4e32fdc.webp",
        "width": 1280,
        "height": 1112
      },
      "poi_business_url": "http://www.collin.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798731976724431200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-campus",
      "poi_latitude": "33.2181719",
      "poi_longitude": "-96.6418315",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-548-6790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGR5rDHUTTIYRYMG_K7byWV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a040eadb78ee1f5817f34fab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Collin Higher Education Center",
      "poi_type": "Education",
      "poi_address": "3452 TX-399 Spur, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5ade-745d-a832-dc966227e208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5ade-745d-a832-dc966227e208",
        "storage_key": "property/5673855012044800/019f1502-5ade-745d-a832-dc966227e208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.collin.edu/campuses/chec/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11293850716588004199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-higher-education-center",
      "poi_latitude": "33.1623281",
      "poi_longitude": "-96.6388395",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-599-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHeqDRmYRTIYRZ9OErGPRu5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_046ec726d76ced536caf43ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Moviehouse & Eatery by Cinépolis McKinney",
      "poi_type": "Entertainment",
      "poi_address": "8450 State Hwy 121, McKinney, TX 75070, USA",
      "poi_short_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_long_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-588e-770b-b225-8be9159d5c3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-588e-770b-b225-8be9159d5c3c",
        "storage_key": "property/5673855012044800/019f1502-588e-770b-b225-8be9159d5c3c.webp",
        "width": 1080,
        "height": 723
      },
      "poi_business_url": "https://www.cinepolisusa.com/mckinney/theater-details",
      "poi_directions_map_url": "https://maps.google.com/?cid=16443355414473898495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moviehouse--eatery-by-cinpolis-mckinney",
      "poi_latitude": "33.1301828",
      "poi_longitude": "-96.7237689",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-854-6754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e6-734d-84e2-399bd0d74ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e6-734d-84e2-399bd0d74ded",
        "storage_key": "property/5673855012044800/019f1502-85e6-734d-84e2-399bd0d74ded.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yAuO0kWTIYR_3k2-6CIMuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_1a74fd15cedcf1ee5daa238f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Cinemark North McKinney XD and SCREENX",
      "poi_type": "Entertainment",
      "poi_address": "1701 N Hardin Blvd, McKinney, TX 75071, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5a20-700c-9ac8-86b4303b0369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5a20-700c-9ac8-86b4303b0369",
        "storage_key": "property/5673855012044800/019f1502-5a20-700c-9ac8-86b4303b0369.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-mckinney/cinemark-north-mckinney-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10252249500917500255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-north-mckinney-xd-and-screenx",
      "poi_latitude": "33.2155667",
      "poi_longitude": "-96.66377620000002",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-491-1822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e6-734d-84e2-399bd0d74ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e6-734d-84e2-399bd0d74ded",
        "storage_key": "property/5673855012044800/019f1502-85e6-734d-84e2-399bd0d74ded.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8N6DAQTTIYRXwndMppOR44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_4f88b30f42400fe74991cf31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "111 N Tennessee St, McKinney, TX 75069, USA",
      "poi_short_description": "Casual theater in McKinney Square hosting plays and other performances, some featuring local actors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5b81-73ad-99ba-4312766d370c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5b81-73ad-99ba-4312766d370c",
        "storage_key": "property/5673855012044800/019f1502-5b81-73ad-99ba-4312766d370c.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.mckinneytexas.org/117/Performing-Arts-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798118788568965204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-performing-arts-center",
      "poi_latitude": "33.1974628",
      "poi_longitude": "-96.6154049",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-547-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYqtnEkSTIYRVOCPLQXFV14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_27eef4b1b0ab1149b66fe850",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Heard Natural Science Museum & Wildlife Sanctuary",
      "poi_type": "Entertainment",
      "poi_address": "1 Nature Pl, McKinney, TX 75069, USA",
      "poi_short_description": "Nature trails, gardens & exhibits such as animatronic dinosaurs & an 1880s prairie village.",
      "poi_long_description": "Nature trails, gardens & exhibits such as animatronic dinosaurs & an 1880s prairie village.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-e8e8-75bc-a93f-9e125fa43132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-e8e8-75bc-a93f-9e125fa43132",
        "storage_key": "property/5673855012044800/019d02ef-e8e8-75bc-a93f-9e125fa43132.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.heardmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9562119403549279734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heard-natural-science-museum--wildlife-sanctuary",
      "poi_latitude": "33.1579212",
      "poi_longitude": "-96.6151955",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-562-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8JZ85sRTIYR9sVsbO94s4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_1bd7bc9d931e315ed70abe2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Chestnut Square Historic Village and Museum",
      "poi_type": "Entertainment",
      "poi_address": "315 S Chestnut St, McKinney, TX 75069, USA",
      "poi_short_description": "Preserved village with houses dating from 1854 to 1930, plus a general store, events & tours.",
      "poi_long_description": "Preserved village with houses dating from 1854 to 1930, plus a general store, events & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5f88-712b-a686-7868c13a8d2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5f88-712b-a686-7868c13a8d2e",
        "storage_key": "property/5673855012044800/019f1502-5f88-712b-a686-7868c13a8d2e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.chestnutsquare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16712275687704230992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut-square-historic-village-and-museum",
      "poi_latitude": "33.1943718",
      "poi_longitude": "-96.6128815",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-562-8790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVS8tDcSTIYRUPwBSjHu7ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "ec_fd38324fb21ab53133aac3d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Collin County History Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 E Virginia St, McKinney, TX 75069, USA",
      "poi_short_description": "Local history museum with artifacts, photos, diaries & archival newspapers, plus monthly events.",
      "poi_long_description": "Local history museum with artifacts, photos, diaries & archival newspapers, plus monthly events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5f2b-710f-b259-6568bf9af4f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5f2b-710f-b259-6568bf9af4f1",
        "storage_key": "property/5673855012044800/019f1502-5f2b-710f-b259-6568bf9af4f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.collincountyhistorymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9259198176168930411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-county-history-museum",
      "poi_latitude": "33.1977221",
      "poi_longitude": "-96.6131736",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-542-9457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fcd1-769b-af6b-7646e347eec9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fcd1-769b-af6b-7646e347eec9",
        "storage_key": "property/5673855012044800/019d02ef-fcd1-769b-af6b-7646e347eec9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZUwrEkSTIYRa2x-E69Hf4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2b5d9c935ea22e69210203d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "TUPPS Brewery",
      "poi_type": "Entertainment",
      "poi_address": "402 E Louisiana St Bldg 2, McKinney, TX 75069, USA",
      "poi_short_description": "Brewery housed in an old cotton mill, offering regular happy hours, weekend tours & tastings.",
      "poi_long_description": "Brewery housed in an old cotton mill, offering regular happy hours, weekend tours & tastings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5f2a-7682-9fbe-1ba95b795382.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5f2a-7682-9fbe-1ba95b795382",
        "storage_key": "property/5673855012044800/019f1502-5f2a-7682-9fbe-1ba95b795382.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tuppsbrewery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15585296061985480418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tupps-brewery",
      "poi_latitude": "33.1964827",
      "poi_longitude": "-96.6099929",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 214-856-7996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7RX6C8STIYR4l7wpTEYStg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_30c9caf9549242419f029417",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3150 S Hardin Blvd, McKinney, TX 75070, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-cf7f-752c-a910-ecc1add404c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-cf7f-752c-a910-ecc1add404c8",
        "storage_key": "property/5673855012044800/019d02ef-cf7f-752c-a910-ecc1add404c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-mckinney/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16341390045620196206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "33.1665362",
      "poi_longitude": "-96.6664791",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-532-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fsI120XTIYRbtNLhapHyOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_d5d6b15723a5299fa18f3ab1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Escapology Escape Rooms McKinney",
      "poi_type": "Entertainment",
      "poi_address": "3150 S Hardin Blvd, McKinney, TX 75070, USA",
      "poi_short_description": "Escape room center with 2+ players working together to get out of a locked room by finding clues, solving puzzles and picking locks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5f30-71b5-8b34-f2d11f5b9d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5f30-71b5-8b34-f2d11f5b9d47",
        "storage_key": "property/5673855012044800/019f1502-5f30-71b5-8b34-f2d11f5b9d47.webp",
        "width": 680,
        "height": 453
      },
      "poi_business_url": "https://www.escapology.com/en/mckinney-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15251542222387974736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "escapology-escape-rooms-mckinney",
      "poi_latitude": "33.1666102",
      "poi_longitude": "-96.666529",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-421-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQ0CX2QXTIYRUJJOWthcqNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_20586f328ed9c4476ca9fb30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Myers Park & Event Center",
      "poi_type": "Entertainment",
      "poi_address": "7117 Co Rd 166, McKinney, TX 75071, USA",
      "poi_short_description": "Venue for weddings, concerts, horse shows and dog races, plus a museum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6101-702f-9c42-c38a30c2b1fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6101-702f-9c42-c38a30c2b1fe",
        "storage_key": "property/5673855012044800/019f1502-6101-702f-9c42-c38a30c2b1fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2816418575038343258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "myers-park--event-center",
      "poi_latitude": "33.271192",
      "poi_longitude": "-96.68106000000002",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-548-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yU9q0ZrTIYRWuj4n8XtFSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_5a2684c6aeef005e35104f4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Methodist McKinney Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "8000 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-63da-770c-af6c-073da7d9aed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-63da-770c-af6c-073da7d9aed2",
        "storage_key": "property/5673855012044800/019f1502-63da-770c-af6c-073da7d9aed2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://methodistmckinneyhospital.com/?utm_source=GMB&utm_medium=local&utm_campaign=Methodist-McKinney-Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3845892487275361530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-mckinney-hospital",
      "poi_latitude": "33.1766691",
      "poi_longitude": "-96.7226843",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-569-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fcd1-769b-af6b-7a80e0b6a58d",
        "storage_key": "property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeRdYtsVTIYR-jRkPNdaXzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_27eb7c1b89376cc0e6c9f963",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - McKinney Stonebridge Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "6200 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6437-75e2-8863-c2fb9844cba1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6437-75e2-8863-c2fb9844cba1",
        "storage_key": "property/5673855012044800/019f1502-6437-75e2-8863-c2fb9844cba1.webp",
        "width": 1131,
        "height": 636
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/mckinney-stonebridge-ranch?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13440485890486403271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---mckinney-stonebridge-ranch",
      "poi_latitude": "33.1746526",
      "poi_longitude": "-96.6973062",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-617-4130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZV29iUUTIYRx4AX57Qyhro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_98722890ca8399e8db22ed0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Eldorado Pkwy Walgreens, McKinney, TX 75070, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-51c8-753f-889b-481a615f9f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-51c8-753f-889b-481a615f9f3e",
        "storage_key": "property/5673855012044800/019f1502-51c8-753f-889b-481a615f9f3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3001+eldorado+pkwy-mckinney-tx-75070/id=4663",
      "poi_directions_map_url": "https://maps.google.com/?cid=10510386196824957680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.1671841",
      "poi_longitude": "-96.6654986",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-540-6667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6LarDkXTIYR8KLrQY9k3JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_4ac0630686780e1dbb37e72e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6301 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-4ac5-7388-86d8-f0cb7abfbd9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-4ac5-7388-86d8-f0cb7abfbd9f",
        "storage_key": "property/5673855012044800/019f1502-4ac5-7388-86d8-f0cb7abfbd9f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mckinney-tx-pharmacies/6301-el-dorado-pkwy-mckinney-tx-75070/storeid=5799?WT.mc_id=LS_GOOGLE_RX_5799",
      "poi_directions_map_url": "https://maps.google.com/?cid=4209497963988613057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.1734079",
      "poi_longitude": "-96.6989883",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-542-4356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e3-74b3-9439-36c7f26e1f10",
        "storage_key": "property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Y1kuoYVTIYRwXdFahgkazo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1c46819d26ee382e135f3a72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 McKinney Ranch Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-65b5-7080-b200-f2032727527a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-65b5-7080-b200-f2032727527a",
        "storage_key": "property/5673855012044800/019f1502-65b5-7080-b200-f2032727527a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/5211-mckinney-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16529816442623428493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.1560381",
      "poi_longitude": "-96.6823574",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-529-2187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85e3-74b3-9439-36c7f26e1f10",
        "storage_key": "property/5673855012044800/019f1502-85e3-74b3-9439-36c7f26e1f10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzbH4bwWTIYRjQf70Hm0ZeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d66a5431645afde1557606b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "F45 Training South McKinney",
      "poi_type": "Health and Wellness",
      "poi_address": "2890 Craig Dr Ste 140, McKinney, TX 75072, USA",
      "poi_short_description": "Friendly staff lead group exercise sessions at this functional fitness franchise.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-65b6-759b-bc9c-f442c2a7e990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-65b6-759b-bc9c-f442c2a7e990",
        "storage_key": "property/5673855012044800/019f1502-65b6-759b-bc9c-f442c2a7e990.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://f45training.com/studio/southmckinney/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10923393960658129999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-south-mckinney",
      "poi_latitude": "33.1747786",
      "poi_longitude": "-96.6434075",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-954-2395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaqe8VITTIYRT9Ssvu6wl5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_223944cb4c78c6b1c61b6fc9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2875 S Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "Health-club chain featuring an array of classes, weight machines, free weights and gym equipment for members.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f14fb-9c2d-76c7-a1bf-fe85fb3610b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-9c2d-76c7-a1bf-fe85fb3610b1",
        "storage_key": "property/5673855012044800/019f14fb-9c2d-76c7-a1bf-fe85fb3610b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=301&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10657477064975616531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.1737289",
      "poi_longitude": "-96.6378173",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-952-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_y2od8TTIYRE4q-w-z25pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f4c112e72bf5e99cb866f3dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "117 S Central Expy, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f14fb-977f-70f8-bd5b-996355358a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-977f-70f8-bd5b-996355358a42",
        "storage_key": "property/5673855012044800/019f14fb-977f-70f8-bd5b-996355358a42.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mckinney-central-expy-tx?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2560030239414489793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.1970221",
      "poi_longitude": "-96.6370058",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-936-0906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3woyVDMTTIYRwRKPavANhyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_e6013a18c31e63d474ac14d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Movement Center - Pilates, GYROTONIC® Exercise, Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "7951 Collin McKinney Pkwy Ste 1575, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6cc1-71f8-9d3b-f4d9354093e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6cc1-71f8-9d3b-f4d9354093e1",
        "storage_key": "property/5673855012044800/019f1502-6cc1-71f8-9d3b-f4d9354093e1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mckinneymovementcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9412942377191862559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-movement-center---pilates-gyrotonic-exercise-yoga",
      "poi_latitude": "33.1395268",
      "poi_longitude": "-96.7190641",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-213-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfIS7GwXTIYRH_G9Wzh9oYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ac8861141c2e8a759b1afc8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Gabe Nesbitt Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7001 Eldorado Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Park offering lighted baseball & softball fields, a tennis complex, a skate park & a bike trail.",
      "poi_long_description": "Park offering lighted baseball & softball fields, a tennis complex, a skate park & a bike trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6756-76b5-a272-035d5e3231ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6756-76b5-a272-035d5e3231ef",
        "storage_key": "property/5673855012044800/019f1502-6756-76b5-a272-035d5e3231ef.webp",
        "width": 1280,
        "height": 986
      },
      "poi_business_url": "https://www.mckinneytexas.org/1510/Gabe-Nesbitt-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3925977338332593932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabe-nesbitt-community-park",
      "poi_latitude": "33.1712217",
      "poi_longitude": "-96.7122236",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-547-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93wSrtUVTIYRDD-Mp5bfezY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_35654368ed090c9921cd8363",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "E.A. Randles Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5400 Cedar Elm Dr, McKinney, TX 75070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6c59-7765-9209-2c92375f484a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6c59-7765-9209-2c92375f484a",
        "storage_key": "property/5673855012044800/019f1502-6c59-7765-9209-2c92375f484a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mckinneytexas.org/857/EA-Randles-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2391150780180777569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ea-randles-park",
      "poi_latitude": "33.1681413",
      "poi_longitude": "-96.6882062",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fv9NmoXTIYRYcoSOfcSLyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7764e00b4d160cfbe7f78f25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Serenity Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6701 Berkshire Rd, McKinney, TX 75070, USA",
      "poi_short_description": "16.79-acre park with open space, a pond & fishing pier, plus a picnic shelter, tot lot & trail.",
      "poi_long_description": "16.79-acre park with open space, a pond & fishing pier, plus a picnic shelter, tot lot & trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6cc3-71ab-a10e-2f31e90dce9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6cc3-71ab-a10e-2f31e90dce9d",
        "storage_key": "property/5673855012044800/019f1502-6cc3-71ab-a10e-2f31e90dce9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mckinneytexas.org/865/Serenity-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14414147097257221246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serenity-park",
      "poi_latitude": "33.1771975",
      "poi_longitude": "-96.7050052",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-547-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9M_HC0UTIYRfpw-YGpWCcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_39810a2a0e58a6b2db99de04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Valley Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2750 Valley Creek Trail, McKinney, TX 75072, USA",
      "poi_short_description": "This 5-acre outdoor space offers grass fields for baseball & soccer, a pavilion & a kids' play set.",
      "poi_long_description": "This 5-acre outdoor space offers grass fields for baseball & soccer, a pavilion & a kids' play set.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6ff4-731f-8f35-44cc4d9cf8b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6ff4-731f-8f35-44cc4d9cf8b7",
        "storage_key": "property/5673855012044800/019f1502-6ff4-731f-8f35-44cc4d9cf8b7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mckinneytexas.org/869/Valley-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9010565720606853371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-creek-park",
      "poi_latitude": "33.171366",
      "poi_longitude": "-96.6541237",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfaGzRf0TTIYR-0gVasj1C30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_261c92fc38553d61685261a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "The Crape Myrtle Trails of McKinney",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6452 Collin McKinney Pkwy, McKinney, TX 75070, USA",
      "poi_short_description": "Park featuring colorful blooms, a paved trail, and shaded tables for picnics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6b92-73de-bc4f-6fa60824d11a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6b92-73de-bc4f-6fa60824d11a",
        "storage_key": "property/5673855012044800/019f1502-6b92-73de-bc4f-6fa60824d11a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mckinneytexas.org/index.aspx?NID=910",
      "poi_directions_map_url": "https://maps.google.com/?cid=14163917374294459188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-crape-myrtle-trails-of-mckinney",
      "poi_latitude": "33.1459937",
      "poi_longitude": "-96.7029926",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-547-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaVkz_QWTIYRNAPO6s5XkMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fe4c99ec0e5c253cf101a397",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Bonnie Wenk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2996 Virginia Pkwy, McKinney, TX 75071, USA",
      "poi_short_description": "Park with an amphitheater & fishing pond plus a dedicated splash area, car park & trail for dogs.",
      "poi_long_description": "Park with an amphitheater & fishing pond plus a dedicated splash area, car park & trail for dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-e89a-70ed-9e79-d1c90c1d6aa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-e89a-70ed-9e79-d1c90c1d6aa7",
        "storage_key": "property/5673855012044800/019d02ef-e89a-70ed-9e79-d1c90c1d6aa7.webp",
        "width": 1024,
        "height": 512
      },
      "poi_business_url": "https://www.mckinneytexas.org/1148/Bonnie-Wenk-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17385907888518791576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonnie-wenk-park",
      "poi_latitude": "33.1982361",
      "poi_longitude": "-96.6620671",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-547-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6CZK4oTTIYRmAHTMBwnR_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_5a435bcf93281b9ffc20c00a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Towne Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1405 Wilson Creek Pkwy, McKinney, TX 75069, USA",
      "poi_short_description": "Park boasting a large lake with a fishing pier & paddleboat rentals plus trails & a playground.",
      "poi_long_description": "Park boasting a large lake with a fishing pier & paddleboat rentals plus trails & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f14fb-b2da-70de-8898-ec028c93440e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b2da-70de-8898-ec028c93440e",
        "storage_key": "property/5673855012044800/019f14fb-b2da-70de-8898-ec028c93440e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mckinneytexas.org/912/Towne-Lake-Recreation-Area",
      "poi_directions_map_url": "https://maps.google.com/?cid=16061805727982545681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "towne-lake-park",
      "poi_latitude": "33.1849258",
      "poi_longitude": "-96.6323446",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-547-2690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-z_Fc8MTTIYREeu74zX_5t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_8442ac3486e06a1c9c8bee2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Dr. Charles B. McKissick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2702 Taylor Burk Dr, McKinney, TX 75071, USA",
      "poi_short_description": "Clean destination for kids featuring swings, slides, a playground and an open field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-70b6-753d-ba5a-fd4c1fdb62e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-70b6-753d-ba5a-fd4c1fdb62e0",
        "storage_key": "property/5673855012044800/019f1502-70b6-753d-ba5a-fd4c1fdb62e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mckinneytexas.org/856/Dr-Charles-B-McKissick-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16004819265374696263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-charles-b-mckissick-park",
      "poi_latitude": "33.2245303",
      "poi_longitude": "-96.6495684",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 469-222-1606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-MLCXETTIYRR7P8HlOKHN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eb424ad347b984cad41e26e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Erwin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4300 Co Rd 1006, McKinney, TX 75071, USA",
      "poi_short_description": "Popular park featuring paved and off-road trails, playgrounds, campgrounds and pavilions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-6b92-73de-bc4f-6a532a6ce4a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-6b92-73de-bc4f-6a532a6ce4a5",
        "storage_key": "property/5673855012044800/019f1502-6b92-73de-bc4f-6a532a6ce4a5.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "https://www.mckinneytexas.org/885/Erwin-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4702118562572751570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "erwin-park",
      "poi_latitude": "33.2572047",
      "poi_longitude": "-96.6543587",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-547-2690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2fsz6kUTIYR0lLrdetHQUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_03e1f0b030930c2ad8783930",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Oak Point Park and Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5901 Los Rios Blvd, Plano, TX 75074, USA",
      "poi_short_description": "Natural 800-acre park around a small lake with a pavilion, amphitheater & nearly 13 miles of trails.",
      "poi_long_description": "Natural 800-acre park around a small lake with a pavilion, amphitheater & nearly 13 miles of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-70bc-746b-9bf1-ff19b3c5ef63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-70bc-746b-9bf1-ff19b3c5ef63",
        "storage_key": "property/5673855012044800/019f1502-70bc-746b-9bf1-ff19b3c5ef63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.plano.gov/1476/Oak-Point-Park-Nature-Preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=54618805310790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-point-park-and-nature-preserve",
      "poi_latitude": "33.0577257",
      "poi_longitude": "-96.67133470000002",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 972-941-7250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fffa-744c-a164-2c888bc77356",
        "storage_key": "property/5673855012044800/019d02ef-fffa-744c-a164-2c888bc77356.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3i4N40ZTIYR1RqbmIMLwgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_dfca851a48f287dd09eddafb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "TAPS McKinney Park & Ride Location",
      "poi_type": "Transportation & Transit",
      "poi_address": "1870 Gateway Blvd, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tapsbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16435280242889066757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taps-mckinney-park--ride-location",
      "poi_latitude": "33.1629899",
      "poi_longitude": "-96.639567",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-256-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85ef-73ca-aacd-81111f5853bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85ef-73ca-aacd-81111f5853bb",
        "storage_key": "property/5673855012044800/019f1502-85ef-73ca-aacd-81111f5853bb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7ybU2YRTIYRBQlmlU3YFeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e3a225853d68141aa504cf0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Parker Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2600 Archerwood St, Plano, TX 75023, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7171-76ca-921c-c5be8501b4eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7171-76ca-921c-c5be8501b4eb",
        "storage_key": "property/5673855012044800/019f1502-7171-76ca-921c-c5be8501b4eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17886008671511646165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parker-road-station",
      "poi_latitude": "33.03586180000001",
      "poi_longitude": "-96.7013125",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-85ef-73ca-aacd-81111f5853bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1502-85ef-73ca-aacd-81111f5853bb",
        "storage_key": "property/5673855012044800/019f1502-85ef-73ca-aacd-81111f5853bb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4NUJ6oZTIYR1Q8CYx_eN_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_35e20697e6356c5cd97cac9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Air Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1508 Industrial Blvd, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-74a9-742c-9e35-0855ae33ba33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-74a9-742c-9e35-0855ae33ba33",
        "storage_key": "property/5673855012044800/019f1502-74a9-742c-9e35-0855ae33ba33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flytki.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7948839885821845744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-air-center",
      "poi_latitude": "33.1766553",
      "poi_longitude": "-96.5925003",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-547-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydwcNBwSTIYR8CDe6sLzT24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_2c08a7e43cee2b4a980b1732",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7577-748e-a5e8-b6c9f6482967.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7577-748e-a5e8-b6c9f6482967",
        "storage_key": "property/5673855012044800/019f1502-7577-748e-a5e8-b6c9f6482967.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "36.2 mi",
      "poi_walking_minutes": "13 hours 23 mins",
      "poi_biking_minutes": "3 hours 25 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02f0-0009-71de-bdfd-af2eb4436d33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-0009-71de-bdfd-af2eb4436d33",
        "storage_key": "property/5673855012044800/019d02f0-0009-71de-bdfd-af2eb4436d33.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_054ccf71017346ad0368c8da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Eldorado Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "2811-2975 Craig Dr, McKinney, TX 75070, USA",
      "poi_short_description": "Shopping mall with a mix of essential stores and restaurants, including a popular grocery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7d26-7374-9674-ace376f93990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7d26-7374-9674-ace376f93990",
        "storage_key": "property/5673855012044800/019f1502-7d26-7374-9674-ace376f93990.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.whitestonereit.com/communities/?propertyId=eldorado-plaza-mckinney-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8414984886700739556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eldorado-plaza",
      "poi_latitude": "33.1729371",
      "poi_longitude": "-96.6418902",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-824-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e7-74ed-8f81-70153b119b68",
        "storage_key": "property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_a_rc-ATTIYR5AsUgisIyHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_472a1bf950a078ca2b0ca70b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "AT&T Store",
      "poi_type": "Transportation & Transit",
      "poi_address": "1801 N Hardin Blvd, McKinney, TX 75071, USA",
      "poi_short_description": "Retailer providing wireless plans & a range of phones, devices & accessories.",
      "poi_long_description": "Retailer providing wireless plans & a range of phones, devices & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-774a-719b-84cb-eebb6dced38e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-774a-719b-84cb-eebb6dced38e",
        "storage_key": "property/5673855012044800/019f1502-774a-719b-84cb-eebb6dced38e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.att.com/stores/texas/mckinney/175985?source=E-g2s10000000000X&wtExtndSource=stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=3765609768489224093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "att-store",
      "poi_latitude": "33.21609",
      "poi_longitude": "-96.66205",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-301-2622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e7-74ed-8f81-70153b119b68",
        "storage_key": "property/5673855012044800/019d02ef-f8e7-74ed-8f81-70153b119b68.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2bhtN74TTIYRnYeKJSIiQjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "ec_ca1ea25eabf47a60d2fb3082",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Raytheon Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7884-70d9-abd8-8bf2f83e280d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7884-70d9-abd8-8bf2f83e280d",
        "storage_key": "property/5673855012044800/019f1502-7884-70d9-abd8-8bf2f83e280d.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://rtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10656069722042240630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raytheon-company",
      "poi_latitude": "33.2151406",
      "poi_longitude": "-96.6499663",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-952-2007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_aDPxoITTIYRdo4fNPT24ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f7eed1e808728c04679b5e6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Medical City McKinney",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 Medical Center Dr, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-e201-72df-ae52-254a86984b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-e201-72df-ae52-254a86984b79",
        "storage_key": "property/5673855012044800/019d02ef-e201-72df-ae52-254a86984b79.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-mckinney-hospital?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6127100865065554328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-mckinney",
      "poi_latitude": "33.1602913",
      "poi_longitude": "-96.6371158",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-547-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fcd1-769b-af6b-7a80e0b6a58d",
        "storage_key": "property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8aWWSW8RTIYRmJE4JcbVB1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_921a6651b0b933b61e8e16c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Baylor Scott & White Medical Center - McKinney",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5252 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-e2c1-739a-b3ac-8959f8b86415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ef-e2c1-739a-b3ac-8959f8b86415",
        "storage_key": "property/5673855012044800/019d02ef-e2c1-739a-b3ac-8959f8b86415.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/mckinney?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717573",
      "poi_directions_map_url": "https://maps.google.com/?cid=13053395923665302371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-medical-center---mckinney",
      "poi_latitude": "33.221056",
      "poi_longitude": "-96.682481",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-764-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fcd1-769b-af6b-7a80e0b6a58d",
        "storage_key": "property/5673855012044800/019d02ef-fcd1-769b-af6b-7a80e0b6a58d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5qYi4sUTIYRYzOaxm76JrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_94ce45d4307cbb11aca54822",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Collin County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 Bloomdale Rd, McKinney, TX 75071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-77c7-7210-a117-a3e76d0b028e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-77c7-7210-a117-a3e76d0b028e",
        "storage_key": "property/5673855012044800/019f1502-77c7-7210-a117-a3e76d0b028e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.collincountytx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8332840972626790253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-county-courthouse",
      "poi_latitude": "33.241655",
      "poi_longitude": "-96.6319199",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-548-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02f0-005b-7649-b0df-e4ce21d8b4f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-005b-7649-b0df-e4ce21d8b4f3",
        "storage_key": "property/5673855012044800/019d02f0-005b-7649-b0df-e4ce21d8b4f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-akLD0TTIYRbYc9H7cypHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_3efbe77f06011d6a79b9bd36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "City of McKinney",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 E Virginia St, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7c5e-7098-a972-34030300a032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7c5e-7098-a972-34030300a032",
        "storage_key": "property/5673855012044800/019f1502-7c5e-7098-a972-34030300a032.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mckinneytexas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4828648537502072262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-mckinney",
      "poi_latitude": "33.1985852",
      "poi_longitude": "-96.6097986",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-547-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02f0-005b-7649-b0df-e4ce21d8b4f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-005b-7649-b0df-e4ce21d8b4f3",
        "storage_key": "property/5673855012044800/019d02f0-005b-7649-b0df-e4ce21d8b4f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86thckkSTIYRxj0F90LOAkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_0f62e0c7403f035c363d61d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 W University Dr, McKinney, TX 75071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5a67-7526-a0f9-4df8e4e32fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5a67-7526-a0f9-4df8e4e32fdc",
        "storage_key": "property/5673855012044800/019f1502-5a67-7526-a0f9-4df8e4e32fdc.webp",
        "width": 1280,
        "height": 1112
      },
      "poi_business_url": "http://www.collin.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798731976724431200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-campus",
      "poi_latitude": "33.2181719",
      "poi_longitude": "-96.6418315",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-548-6790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGR5rDHUTTIYRYMG_K7byWV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_eecb2a01818d65d16b3d588f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Collin Higher Education Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3452 TX-399 Spur, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-5ade-745d-a832-dc966227e208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-5ade-745d-a832-dc966227e208",
        "storage_key": "property/5673855012044800/019f1502-5ade-745d-a832-dc966227e208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.collin.edu/campuses/chec/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11293850716588004199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-higher-education-center",
      "poi_latitude": "33.1623281",
      "poi_longitude": "-96.6388395",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-599-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHeqDRmYRTIYRZ9OErGPRu5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_df2b945db26536da5fb6f715",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Duvall St, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7c5b-710a-8e97-5ecb06b273e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7c5b-710a-8e97-5ecb06b273e4",
        "storage_key": "property/5673855012044800/019f1502-7c5b-710a-8e97-5ecb06b273e4.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.mckinneyisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310830033991206390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-independent-school-district",
      "poi_latitude": "33.206801",
      "poi_longitude": "-96.6322933",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-302-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-f8e9-724a-aeac-b8373818a66f",
        "storage_key": "property/5673855012044800/019d02ef-f8e9-724a-aeac-b8373818a66f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11AzRaUTTIYR9oX1iPgAMRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_93caf68575a24382fcfc24c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "McKinney National Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1508 Industrial Blvd, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7d8f-7380-850d-4013ab580baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7d8f-7380-850d-4013ab580baa",
        "storage_key": "property/5673855012044800/019f1502-7d8f-7380-850d-4013ab580baa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flytki.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14560522122723772330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckinney-national-airport",
      "poi_latitude": "33.1767774",
      "poi_longitude": "-96.59264",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-984-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02f0-0009-71de-bdfd-af2eb4436d33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f0-0009-71de-bdfd-af2eb4436d33",
        "storage_key": "property/5673855012044800/019d02f0-0009-71de-bdfd-af2eb4436d33.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WCI6BwSTIYRqscqxbldEco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_bc39cb38889b117dd84ac50b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "poi_name": "Old Collin County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 N Tennessee St, McKinney, TX 75069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f1502-7f81-77dc-9408-ce4255445c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-7f81-77dc-9408-ce4255445c2e",
        "storage_key": "property/5673855012044800/019f1502-7f81-77dc-9408-ce4255445c2e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.mckinneytexas.org/631/Our-History",
      "poi_directions_map_url": "https://maps.google.com/?cid=409016701166554165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-collin-county-courthouse",
      "poi_latitude": "33.197588",
      "poi_longitude": "-96.6154057",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ef-fc94-70da-898b-6b30fa61efe9",
        "storage_key": "property/5673855012044800/019d02ef-fc94-70da-898b-6b30fa61efe9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW54GhkkSTIYRNQw8zIUerQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    }
  ],
  "office_hours": [
    {
      "id": "custom_348c5b67-a840-4cbe-8ea0-469f5422836a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5968cbcf-97ea-4fa2-a889-eaab0604c2ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d0c8a1a9-b069-4487-8d59-af7cdc1a4cae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1e5d2a96-b261-4185-aae4-efc95375a5b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f1ffc852-7797-4974-9d2e-bb35ecf5ab38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_820f582b-f4bc-449f-804f-6243f39efdf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c53df541-c953-446b-af86-eba10d71aa42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_52f6355fee8b965c5440eb45",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "great staff, location and apartment. It has everything you could want and more.",
      "date": "false",
      "title": "nice weather"
    },
    {
      "id": "ec_b0a6de6c7a948aa9f828f73a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "Absolutely love our apartments. The staff are very sweet and helpful. Love the valet trash service, swimming pool, laundry services. I feel safe having a gated entry. Spacious rooms and garden tub are awesome.",
      "date": "false",
      "title": "Villas of Eldorado"
    },
    {
      "id": "ec_e5dc9071b5d68527cc2055ef",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "I was impressed by all the nice upgrades to the apartments.  I especially loved the new counter tops - they are impressive!  The community is close to shopping and fine dining.\n\nThanks for a lovely experience - Nadine.",
      "date": "false",
      "title": "Excellent Community to live in"
    },
    {
      "id": "ec_5d6e8632f727ce4a2335244e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "After looking at the reviews I'm excited about going to see the unit... Ashley in the office has been very helpful to say the least.. can't wait to see if this will be my new home",
      "date": "false",
      "title": "Ashley"
    },
    {
      "id": "ec_929ef1eec50fba2e3b6a2888",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "The Ranch is a great place that keeps getting better. Including, and thanks to, the staff. Leasing, managements, and maintenance. All stellar. Have lived here with for 2+ years with my family too.\n\nSince I don't trust reviews that only praise, my only main gripe (and it's minor) is it's difficult for them to enforce their tenants to pick up after their dogs. This is inherently a difficult task and admittedly a petty grip. Don't be confused though. While the community is responsible for this and are lacking in this department. Overall, its a good community too.",
      "date": "false",
      "title": "Amazing place & staff"
    },
    {
      "id": "ec_2e595c9e0690ab9bb7ec13df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "I love these apartments! Not only are they nice, but the location and staff make any shortcomings worthwhile. The ONLY thing I can agree is a negative is the lack of open parking, but I factored that in when choosing my unit and it has not been an issue. Definitely recommend. ",
      "date": "false",
      "title": "Great location and staff; Ashley is Awesome"
    },
    {
      "id": "ec_bb4cc54c13aaf0bb4419886e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "rating": "5",
      "name": "false",
      "text": "I have lived here for almost 2 years and this place has been awesome to live at! The front staff is very kind, people generally pick up after their pets, and the maintenance team is incredible! They usually respond within an hour and actually show up within a day to fix any issue you may be having. \nWhen the heater went out last winter, they brought in 2 space heaters for me and my roommate so we wouldn't freeze. When our sink is clogged, they come immediately. When wasps were building nests in our balcony, they removed them the next day!\nI've never lived in an apartment complex with such a responsive maintenance team, and the guys are very polite, too ??",
      "date": "false",
      "title": "Responsive Maintenance! "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_8ff7582bf3cb2b577ce41afe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f14c3-d7b4-7064-8673-67ed74c0f89b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-d7b4-7064-8673-67ed74c0f89b",
        "storage_key": "property/5673855012044800/019f14c3-d7b4-7064-8673-67ed74c0f89b.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Ranch at Hudson Crossing",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/YPijBIo0_DU"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-e83b-771f-8490-ccf9f89eaa25",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "ranch-at-hudson-xing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800"
    },
    {
      "lead_collector_id": "0198aa45-e8a1-70cd-9cc4-972dc599045f",
      "lead_source": "FACEBOOK_ADS",
      "name": "ranch-at-hudson-xing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800"
    },
    {
      "lead_collector_id": "0198aa45-e905-74f9-a726-bec8a76435a4",
      "lead_source": "LANDING_PAGE",
      "name": "ranch-at-hudson-xing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-mckinney-tx-422",
      "search_query": "luxury apartments with pool in McKinney TX",
      "category": "",
      "h1_title": "Luxury Apartments with Pool in McKinney TX",
      "h2_subtitle": "Discover luxury living at Ranch at Hudson Xing in McKinney, TX. Our elegant apartments offer a pristine pool and upscale amenities for your comfort.",
      "page_copy": "Welcome to Ranch at Hudson Xing, where your search for luxury apartments with pool in McKinney TX ends. Nestled in the vibrant Allen/McKinney neighborhood, our community offers spacious one, two, or three-bedroom floor plans. Each apartment is meticulously designed with features like granite countertops and washer/dryer hookups.\n\nThe centerpiece of our community is the stunning pool, perfect for relaxation or exercise. Beyond the pool, residents enjoy a well-maintained dog park and a professional business center. Managed by a dedicated on-site team, Ranch at Hudson Xing is the epitome of luxurious and convenient living. Discover your new home today and experience the best of McKinney, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in McKinney TX",
      "seo_description": "Explore luxury living at Ranch at Hudson Xing, McKinney TX. Enjoy amenities like a pristine pool and modern features. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "dog-park-apartments-collin-county-989",
      "search_query": "dog park apartments in Collin County",
      "category": "",
      "h1_title": "Dog Park Apartments in Collin County",
      "h2_subtitle": "Find your ideal pet-friendly home at Ranch at Hudson Xing. Our Collin County location features a serene dog park and ample amenities.",
      "page_copy": "Welcome to Ranch at Hudson Xing, the best choice for dog park apartments in Collin County. Located in the vibrant community of McKinney, TX, our apartments cater to pet lovers with a serene, expansive dog park designed for endless fun and exercise with your furry friends. Choose from our spacious one, two, or three-bedroom layouts, all equipped with modern conveniences such as granite countertops and washer/dryer hookups.\n\nBeyond the pet-friendly perks, residents enjoy access to luxurious amenities, including a refreshing pool and a well-equipped business center, all managed by an attentive on-site team. Located conveniently in the Allen/McKinney neighborhood, Ranch at Hudson Xing offers the perfect blend of comfort, luxury, and pet-friendly living in Collin County. Schedule a visit and see for yourself!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Collin County",
      "seo_description": "Ranch at Hudson Xing: Ideal pet-friendly apartments in Collin County featuring a dog park, luxurious amenities, and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "modern-mckinney-apartments-with-air-conditioning-37",
      "search_query": "modern McKinney apartments with air conditioning",
      "category": "",
      "h1_title": "Modern McKinney Apartments with Air Conditioning",
      "h2_subtitle": "Experience comfort at Ranch at Hudson Xing. Our McKinney apartments boast modern amenities, including efficient air conditioning.",
      "page_copy": "Ranch at Hudson Xing invites you to explore modern McKinney apartments with air conditioning designed for ultimate comfort and convenience. Situated in the vibrant Allen/McKinney area, our community offers a variety of spacious one, two, or three-bedroom floor plans, each equipped with efficient air conditioning to keep you cool during Texas summers.\n\nBeyond climate control, discover a range of upscale amenities, from a sparkling pool to granite countertops and washer/dryer hookups in every unit. With a dedicated property manager on site, our residents enjoy not only comfort but also peace of mind. Experience modern living in McKinney, where luxury meets practicality every day in Collin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern McKinney Apartments with Air Conditioning",
      "seo_description": "Discover modern living at Ranch at Hudson Xing, McKinney TX. Enjoy our apartments with air conditioning and upscale amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "apartments-with-business-center-allen-mckinney-189",
      "search_query": "apartments with business center in Allen McKinney",
      "category": "",
      "h1_title": "Apartments with Business Center in Allen McKinney",
      "h2_subtitle": "Explore Ranch at Hudson Xing, featuring a modern business center. Our Allen/McKinney apartments offer convenience and upscale living.",
      "page_copy": "Welcome to Ranch at Hudson Xing, your premier destination for apartments with a business center in Allen McKinney. Located strategically in Collin County, our community is perfect for those who blend work and play. Enjoy the convenience of a dedicated business center, perfect for remote work or study sessions, coupled with the comfort of a stylish home.\n\nOur spacious one, two, or three-bedroom apartments are enhanced with modern amenities like granite countertops and washer/dryer hookups. The on-site pool and serene dog park offer relaxation and recreation. At Ranch at Hudson Xing, we combine professional needs with overall lifestyle comfort, making it an ideal place for contemporary living in McKinney, TX. Discover the perfect balance of work and leisure, all within our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Business Center in Allen McKinney",
      "seo_description": "Ranch at Hudson Xing: Allen/McKinney apartments with a modern business center. Enjoy work-life balance with luxurious amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "family-friendly-apartments-playground-75070-566",
      "search_query": "family-friendly apartments with playground in 75070",
      "category": "",
      "h1_title": "Family-Friendly Apartments in 75070",
      "h2_subtitle": "Discover family-friendly living at Ranch at Hudson Xing. Our 75070 community features amenities that cater to every family member.",
      "page_copy": "Welcome to Ranch at Hudson Xing, where you'll find family-friendly apartments in the heart of the 75070 area. Built with families in mind, our community offers a range of spacious one, two, or three-bedroom floor plans that provide the perfect environment for all household sizes. Although we don't have a traditional playground, we offer other family-focused amenities like a serene dog park and a refreshing pool.\n\nOur apartments come with modern features including granite countertops and washer/dryer hookups, allowing you to enjoy both comfort and convenience. Nestled within the vibrant McKinney area, our location offers an easy commute to schools and local attractions, making it a great choice for families. Experience the blend of community and tranquility at Ranch at Hudson Xing, where comfort meets family-friendly living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments in 75070",
      "seo_description": "Ranch at Hudson Xing: Family-oriented apartments in McKinney, TX 75070. Enjoy spacious living with modern amenities and nearby attractions. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-mckinney-tx-467",
      "search_query": "one bedroom apartments McKinney TX",
      "category": "",
      "h1_title": "One Bedroom Apartments in McKinney, TX",
      "h2_subtitle": "Explore the ideal one-bedroom apartments at Ranch at Hudson Xing. Our McKinney, TX location offers modern comforts in a vibrant setting.",
      "page_copy": "Discover the charm of one-bedroom apartments at Ranch at Hudson Xing in McKinney, TX. Our thoughtfully designed floor plans are perfect for singles or couples seeking a cozy yet modern home. Each unit features quality finishes like granite countertops, providing a touch of elegance that's both practical and stylish.\n\nLocated in the lively Allen/McKinney area, our community offers amenities that enhance your daily living experience, including a refreshing pool and a serene dog park for leisure. With a convenient on-site business center and reliable property management, Ranch at Hudson Xing ensures a seamless living experience. Explore the possibilities of residential comfort and convenience in our one-bedroom apartments—your perfect McKinney home awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in McKinney, TX",
      "seo_description": "Find one-bedroom apartments at Ranch at Hudson Xing in McKinney, TX. Modern amenities and comfort in a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-allen-mckinney-241",
      "search_query": "two bedroom apartments Allen/McKinney",
      "category": "",
      "h1_title": "Two Bedroom Apartments in Allen/McKinney",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Ranch at Hudson Xing. Ideal for families or roommates in Allen/McKinney.",
      "page_copy": "Explore the exceptional two-bedroom apartments available at Ranch at Hudson Xing, located conveniently in the Allen/McKinney area. Designed with versatility and style in mind, these spacious units are perfect for families or roommates seeking a well-balanced blend of comfort and utility. Enjoy the luxury of features like granite countertops and washer/dryer hookups, providing modern convenience in your living space.\n\nOur community boasts a range of amenities to enhance your lifestyle, including a tranquil pool area and a dog park, encouraging relaxation and recreation. The on-site business center ensures residents can effortlessly manage work tasks from home. Experience the balance of functionality and comfort with our two-bedroom floor plans in a vibrant neighborhood. Make Ranch at Hudson Xing your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Allen/McKinney",
      "seo_description": "Ranch at Hudson Xing offers spacious two-bedroom apartments in Allen/McKinney. Enjoy modern amenities and a vibrant community. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5673855012044800",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-collin-county-397",
      "search_query": "three bedroom apartments Collin County",
      "category": "",
      "h1_title": "Three Bedroom Apartments in Collin County",
      "h2_subtitle": "Find spacious three-bedroom apartments at Ranch at Hudson Xing. Ideal for families in the heart of Collin County.",
      "page_copy": "Welcome to the spacious three-bedroom apartments at Ranch at Hudson Xing, located in the heart of Collin County. Designed for those needing more room, these expansive floor plans are perfect for growing families or those in need of additional space. Each apartment features top-of-the-line finishes such as granite countertops, ensuring both function and style.\n\nOur community is equipped with family-friendly amenities including a refreshing pool and a serene dog park, fostering a sense of relaxation and community. With a dedicated on-site business center and attentive property management, residents experience seamless convenience. Nestled in the vibrant Allen/McKinney area, Ranch at Hudson Xing provides an inviting environment that caters to all aspects of modern living. Experience the perfect home in Collin County today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and a resort-style building in the background.",
        "public_id": "019f6c10-5d10-724c-b5e7-c5535acd61fd",
        "storage_key": "property/5673855012044800/019f6c10-5d10-724c-b5e7-c5535acd61fd.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Collin County",
      "seo_description": "Ranch at Hudson Xing offers spacious three-bedroom apartments in Collin County. Enjoy modern amenities and an inviting community. Discover your new home now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2187"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471363"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a42\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a42\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4600728"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TMX4T6J"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://ranchathud.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443974197"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dgow3yxqv2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/69de00e8-60e1-4370-ab8c-486e93d59ab5"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "972-787-1192"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjJGM095V1I1UG82cjVYSWhXaDAwb2c9PSIsInZhbHVlIjoicW5abUMxMmJuK0lyS2ZMb25BL09aUT09IiwibWFjIjoiMjg4NDU5YWIxNTNmYTZkZDY1NDkxOWM5YTYwYWY1MDlkOWQ0Y2JmMzJmNDVmMTliM2EwODcxZmNiYWQyNGMxOCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2187",
  "custom_repli_id": "2376471363",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a42\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a42\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4600728",
  "custom_google_gtm_id": "GTM-TMX4T6J",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://ranchathud.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443974197",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dgow3yxqv2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/69de00e8-60e1-4370-ab8c-486e93d59ab5",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "972-787-1192",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjJGM095V1I1UG82cjVYSWhXaDAwb2c9PSIsInZhbHVlIjoicW5abUMxMmJuK0lyS2ZMb25BL09aUT09IiwibWFjIjoiMjg4NDU5YWIxNTNmYTZkZDY1NDkxOWM5YTYwYWY1MDlkOWQ0Y2JmMzJmNDVmMTliM2EwODcxZmNiYWQyNGMxOCJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-30T21:52:33.300Z';
